export default {
  serviceCenter: {
    csServiceCenter: "Service Center",
    abilityAbove07KnowledgePointCount: "Number of Knowledge Points (Ability > 0.7)",
    abilityAtLeast085KnowledgePointCount: "Number of Knowledge Points (Ability ≥ 0.85)",
    abilityAtMost07KnowledgePointCount: "Number of Knowledge Points (Ability ≤ 0.7)",
    abilityAtMost085KnowledgePointCount: "Number of Knowledge Points (Ability ≤ 0.85)",
    abilityImprovement: "Ability Score Improvement",
    account: "Adaptive Account",
    accountActivateDate: "Account Activation Date:",
    accountActivateTime: "Account Activation Time",
    accountBalanceLabel: "Account Balance:",
    accountBindDate: "Account Binding Date",
    accountBindLimitExceeded: "This Learning Tablet cannot bind more accounts. Please unbind an account and try again",
    accountBindMachineTime: "Registration Time:",
    accountBindMachineTimeTitle: "Registration Time",
    accountBindPhone: "Bound Mobile Number",
    accountBindTime: "Account Binding Time",
    accountCannotSubscribe: "This account cannot subscribe at the moment. Please wait for headquarters approval and try again",
    accountFaceUnbind: "This account has been unbound due to face recognition data and cannot be used",
    accountFreeze: "Account Frozen",
    accountLabel: "Account",
    accountNotExist: "Account does not exist",
    accountPausedCannotSubscribe: "This account is paused and cannot subscribe. Please unbind extra accounts or request a limit increase",
    accountPhoneRebind: "Change Account Mobile Number",
    accountRequired: "Account is required",
    accountStatus: "Account Status",
    accountStatusLabel: "Account Status:",
    accountType: "Account Type",
    accountUnbind: "Unbind Account",
    accountUnbindPhoneTip: "This account is not bound to a mobile number and cannot switch Learning Center. Please bind a mobile number first",
    accountUnfreeze: "Unfreeze Account",
    accountUser: "User Account",
    activate: "Activate",
    machineStatusNoActive: "Not Activated",
    machineStatusActive: "Normal",
    activeStudentCount: "Active Student Count",
    activityEndTime: "Activity End Time",
    activityStartTime: "Activity Start Time",
    activitySubject: "Activity Subject",
    adaptiveAccount: "Adaptive Account:",
    adaptiveAccountColon: "Adaptive Account:",
    adaptiveAccountLabel: "Adaptive Account:",
    adaptiveAccountText: "Adaptive Account",
    addFollowRecordTitle: "Add Follow-up Record",
    address: "Address",
    addSuccess: "Added successfully",
    afterMailingPleaseGoTo: "2. After mailing, please go to [Service Center] → [Repair Management] → [",
    age: "Age:",
    agent: "Master Franchisee ID",
    agentId: "Master Franchisee ID",
    agentId26: "Master Franchisee ID",
    agentID408: "Master Franchisee ID",
    agentId48: "Master Franchisee ID",
    agentIdLabel: "Master Franchisee ID:",
    agentLabel: "Master Franchisee",
    agentName: "Master Franchisee Name",
    agentName27: "Master Franchisee Name",
    agentName409: "Master Franchisee Name",
    agentName49: "Master Franchisee Name",
    agentNameLabel: "Master Franchisee Name:",
    all: "All",
    already: "Activated",
    videoCallServiceLabel: 'Video Call Service:',
    notActivatedStatus: 'Not Activated',
    activatedStatus: 'Activated',
    nextDeductTimeLabel: 'Next Deduct Time:',
    remainCallTimeLabel: 'Remaining Call Time Today:',
    cashAccountLabel: 'Cash Account: ',
    dayUnit: 'Day(s)',
    minutePerDayUnit: 'min/day',
    analystName: "Analyst Name",
    analystReviewer1: "Reviewer",
    analystReviewExport: "Analyst Review Export",
    analystReviewSyncCourseStudyLength: "Synced Course Study Time",
    analystWeeklyReport: "Analyst Weekly Report",
    applicationLengthTip: "Please enter 2–50 characters",
    applicationNote: "Application Note",
    applicationNote41: "Application Note",
    applicationNoteLabel: "Application Note:",
    applyAccountSubscriptionAuth: "Apply for Account Subscription Authorization",
    applyAuth: "Apply for Authorization",
    applyAuthConfirmTip: "After confirmation, an authorization request will be sent to the Parent App",
    applyCheckFailed: "Pre-check failed before submission",
    applyElectronicCert: "Apply for Electronic Certificate",
    applyPaperCert: "Apply for Paper Certificate",
    applySuccess: "Application submitted successfully",
    applyTime: "Application Time:",
    applyTipText: "Only students who have not applied are shown. Students who have already applied or are in payment will not be displayed. For orders in payment, please go to \"Procurement Center - Online Orders\"",
    applyTransferServiceCenter: "Apply to Transfer to Learning Center",
    applyTransferSuccessTip: "User {name} ({account}) has submitted a request to transfer to a Learning Center.<br /><br />Please contact the parent to confirm in the Squirrel Ai Parent App. If not confirmed within 7 days, the transfer will fail and must be resubmitted",
    area: "Region",
    area267: "Region",
    areaBalance: "Remaining Regional Time (Gifted or Renewed)",
    areaBalanceLabel: "Remaining Regional Time (Gifted or Renewed):",
    areaBalanceLabelShort: "Regional Time:",
    areaBalanceMonthLabel: "Regional Time (Months, Gifted or Renewed):",
    areaBalanceMonthsLabel: "Regional Time (Months, Gifted or Renewed):",
    areaDuration25: "Regional Time",
    areaDurationBalanceLabel: "Regional Time Balance:",
    audit: "Reviewer",
    auditOpinion: "Review Comments",
    authorizationStatus: "Authorization Status",
    auto_0_3a534d59: "Payment details",
    auto_0_ce0535cf: "Repair category",
    auto_0_daf1dd54: "Select actual handling method",
    auto_067_7601e4b2: "Quotation description:",
    auto_07_84b8cb39: "Product details",
    auto_072_88aee664: "Discount",
    auto_1_0823eb8e: "Select suggested handling method",
    auto_1_165d48be: "Contact 1:",
    auto_1_30bb9873: "checkFaceChangeLearningMachine",
    auto_1_9070e5ca: "No.",
    auto_1_af66dc5d: "Subscribe Subject Management",
    auto_10_f6175120: "Payment Success",
    auto_100_1d863d17: "Enter campus address",
    auto_100_fba7f4c6: "Off-campus full-time",
    auto_101_d439e55b: "Remark",
    auto_101_e2aedd75: "Operation Time",
    auto_102_26f2fe11: "Enter remark (max 200 characters)",
    auto_102_951961f3: "Operation type",
    auto_103_31b2b61a: "Operation",
    auto_103_bd53e7e8: "Operator",
    auto_104_2faa36a6: "Add Goods",
    auto_104_d8c791af: "Gold coins",
    goldCoinBalanceLabel: "Gold Coin Balance: ",
    auto_105_d0cf4135: "Confirm",
    auto_105_e9a92572: "Remark",
    auto_106_4d6d84e4: "Holiday full-time",
    auto_107_1a3ae998: "Off-campus full-time",
    auto_108_10a5fc1e: "You must upload key pages of the agreement",
    auto_109_75af8eab: "2. Full-time study start and end times must match the form; inconsistent entries will be rejected",
    auto_11_2204ab70: "save",
    auto_11_38b63b7f: "Repair amount",
    auto_11_c0ec4324: "Payment Failed",
    auto_110_5f31333c: "Application validity period",
    auto_110_f60501a2: "slotTipStyleColorRedFontSize",
    auto_111_d4b3ffe4: "Operation",
    auto_112_348a9ed7: "Full-time type",
    auto_113_eb7cefd1: "Full-time start/end date",
    auto_114_ee10a1d6: "Signed full-time agreement",
    auto_115_b799aa8a: "Preview",
    auto_116_7aaa417f: "All",
    auto_117_3cc991a0: "Past 6 months",
    auto_118_c9074fd5: "Past year",
    auto_119_64538f3b: "Stage/Grade",
    auto_12_a5aabedb: "confirmUnsubscribe",
    auto_12_b0263010: "Service Center",
    auto_120_7ac3b736: "Course",
    auto_1204_0527e8b9: "Select fault classification",
    auto_121_4d27f7b6: "Copy Link",
    auto_122_1e53b582: "View Report",
    auto_123_7fd832fc: "undefined",
    auto_123_829cdda3: "Manual foundation",
    auto_124_9ab01fc5: "System foundation",
    auto_124_d08c864a: "Please select stage first",
    auto_125_42965969: "Non-foundation",
    auto_125_f9c29978: "Please select course",
    auto_126_833d3bf7: "Video Call ServiceNot Activated",
    auto_126_ac871dbb: "Regular Course",
    auto_127_96e51db7: "Downgrade",
    auto_127_da19ce81: "Video Call ServiceActivated",
    auto_128_f01e330d: "Other",
    auto_128_f729d6ba: "This payment will deduct",
    auto_129_0d59f21f: "Cash Account",
    auto_129_74e0f116: "Formal course retake",
    auto_13_3e7b680b: "Learning device account management",
    auto_13_c9216b74: "confirmWithdrawApply",
    auto_130_7fe93f55: "Remaining Payment",
    auto_130_dc39f9ac: "Foundation upgrade",
    auto_131_4c4eca8d: "Foundation Building Retake",
    auto_131_8d1457b5: "Pay Method",
    auto_132_315490d7: "CancelCloseVideo Call Service",
    auto_132_b843f6aa: "min",
    auto_133_1c97f68c: "Enable auto-renewal? When enabled, the service will renew automatically when it expires.",
    auto_133_d5a9ecd5: "Call Staff Name",
    auto_134_caf9ef8b: "Call StaffAccount",
    auto_134_d87a1bfe: "CloseVideo Call Service",
    auto_1345_4f27ef33: "Actual handling method:",
    auto_135_aa966d94: "Disable auto-renewal? When disabled, the service will not renew automatically when it expires.",
    auto_135_c3004cf6: "Call Time",
    auto_136_8b21a30d: "Open Video Call Service",
    auto_136_f63b4da6: "Call Start Time",
    auto_137_d7353e2e: "Call End Time",
    auto_137_f04bdc99: "*Please upload fault images and customer service chat records confirming factory return, or the application will not be approved.",
    auto_138_06fe2370: "Call Duration",
    auto_138_f9f1009e: "*You can reach customer service in the dealer mini program or dealer system.",
    auto_139_54f25dde: "Agree",
    auto_139_78a7474f: "Pre-K",
    auto_14_3c96af6d: "Confirm to unbind?",
    auto_14_87909680: "Service CenterAccount Management",
    auto_140_0f33945c: "Rejected",
    auto_141_49f1d688: "Local file upload",
    auto_142_3028f9de: "Capture photo / video",
    auto_143_3ffe7afc: "Repair Order No",
    auto_144_25b3044c: "Enter device SN",
    auto_145_51359635: "Product Type",
    auto_146_f1fd1dab: "First timeHardware Activate Time",
    auto_147_4e09be31: "Hardware Activate Time",
    auto_148_ff67d8df: "Software Activate Time",
    auto_149_e5e59bbf: "Dealer Info",
    auto_15_306787ed: "confirmUnbind",
    auto_15_35381be3: "Cancel Unsubscribe",
    auto_150_8216ecc6: "Last repair time",
    auto_151_1f7b6981: "Replacement validity period",
    auto_152_2a3d0b25: "Ship Time",
    auto_153_285a56ac: "Warranty validity period",
    auto_154_ca0155a1: "Estimated fault category",
    auto_155_ae7b9eab: "Please select estimated fault category",
    auto_156_01e9401f: "Detailed Description",
    auto_156_87c3f69b: "Operation Time",
    auto_157_209fc4d7: "Supervisor Status",
    auto_157_f63eef9f: "Please enter a detailed description (max 400 characters)",
    auto_158_1ae39484: "Analyst",
    auto_158_277fad1a: "Upload images / videos",
    auto_159_2e809b36: "Supervision start",
    auto_159_c5f35bbc: "Initial Diagnosis Processing Method",
    auto_16_c75582a9: "Unsubscribe",
    auto_16_fc574e73: "Operation",
    auto_160_0fd0f923: "Initial Diagnosis Processing Method",
    auto_160_b408bfc4: "Supervisor Study End",
    auto_161_0e7074d3: "Initial Diagnosis Processing Method",
    auto_161_b49a624a: "Operator",
    auto_162_2f0acc05: "Remark",
    auto_162_31a2cef4: "Initial Diagnosis Processing Method",
    auto_163_2f65a87d: "Repair RequestCreate",
    auto_163_c4fff688: "Initial Diagnosis Processing Method",
    auto_164_53e12b78: "Initial Diagnosis Processing Method",
    auto_164_b1ee144c: "Repair RequestEdit",
    auto_165_23adb576: "New SN Code",
    auto_165_9314da58: "Repair RequestReview",
    auto_166_c174c9ae: "Enter new SN code",
    auto_166_d7b2c0e5: "Repair RequestReturn shipping",
    auto_167_135f0459: "Actual handling method:",
    auto_167_e572d148: "Repair RequestRepair result",
    auto_168_09e3182c: "Select actual handling method",
    auto_168_60062016: "Repair RequestDetail",
    auto_169_16249d57: "Repair RequestInitial Diagnosis",
    auto_169_82c84a87: "Express Company",
    auto_17_019f198f: "Subscribe Subject Management",
    auto_17_f2e61b71: "Subscribe",
    auto_170_1f52a8fc: "Repair RequestQuality inspection",
    auto_170_b564cbf5: "Select express company",
    auto_171_285012b1: "Express No.",
    auto_171_66f61756: "Repair RequestReturn Express",
    auto_172_a9b0d47b: "Enter express no.",
    auto_172_d902028a: "Repair RequestReinspection result",
    auto_173_10a54dad: "Repair RequestDispute result",
    auto_173_e2ab3dbb: "Return Result",
    auto_174_24572297: "Return images / videos",
    auto_174_809ab92b: "Repair RequestDetection",
    auto_175_4b33805e: "Reinspection remark",
    auto_175_f63053de: "Repair RequestFill in quote",
    auto_176_47f30660: "Enter remark (max 400 characters)",
    auto_176_98a3a89c: "Repair RequestRepair payment",
    auto_177_5b24c14c: "Purchase Order No.",
    auto_177_eb22414a: "Upload images / videos",
    auto_178_21da1dc7: "device",
    auto_178_a2a89126: "Faulty device shipping info:",
    auto_179_8fedbfef: "Return address after repair completion:",
    auto_179_ea268695: "Reinspection result",
    auto_18_09bd5a0c: "Subscribe Confirm",
    auto_18_bf0e2367: "studentAccount",
    auto_180_81a0f685: "After-sales handling method:",
    auto_180_b0944925: "Dispute result",
    auto_181_8d94fe0c: "Repair Vendor:",
    auto_181_fb5da079: "Passed",
    auto_182_210ff69d: "Normal",
    auto_182_dc5a4269: "Manufacturer receiving address:",
    auto_183_7d26588a: "Express Company:",
    auto_183_fa970116: "Not approved",
    auto_184_147c7ae0: "Poor",
    auto_184_4833177f: "Select express company",
    auto_185_9217b812: "Repair RequestCreate",
    auto_185_9a01a66f: "Express No",
    auto_185800506_58c5517a: "Log statistics start time: 2022-03-10 18:58:00",
    auto_185800514_285eb524: "Log statistics start time: March 10, 2022",
    auto_186_63c16dc2: "Enter express no",
    auto_186_b8cb9234: "Repair RequestEdit",
    auto_187_9b32ddbc: "Device return recipient name:",
    auto_187_dcb316c0: "Repair RequestReview",
    auto_188_38add320: "Repair RequestReturn shipping",
    auto_188_fbfd4735: "Enter device return recipient name",
    auto_189_8f2748d7: "Repair RequestRepair result",
    auto_189_f1c2c6f8: "Device return recipient phone:",
    auto_19_057b7f8e: "Cancel Subscribe",
    auto_19_5502194f: "studentName",
    auto_190_02e41171: "Repair RequestDetail",
    auto_190_5dc58112: "Enter device return recipient phone",
    auto_191_0e819a56: "Address is too brief; please provide full details:",
    auto_191_a87f2af7: "Device return shipping address:",
    auto_192_47a2745e: "No data",
    auto_192_6864fd19: "Select province/city/district",
    auto_193_04ebeeef: "e.g. Province, City, District, Street, No.",
    auto_194_0b4ed967: "Handling communicated to parent:",
    auto_195_04d273c0: "Select after-sales method",
    auto_195_33d0c0b0: "Purchase Order No.",
    auto_196_50634837: "device SN：",
    auto_196_af1d4694: "New device SN for parent:",
    auto_197_58238cdc: "Enter new device SN",
    auto_198_d201175c: "Read fault description",
    auto_199_058a9250: "Agree",
    auto_2_037c31fd: "Select suggested handling method",
    auto_2_1c595e87: "Unbind",
    auto_2_20f54b4b: "Fill-in result:",
    auto_2_34b654fd: "Confirm",
    auto_2_845314ef: "SN code:",
    auto_2_905c20d8: "checkFaceChangeLearningMachine",
    auto_2_ab5a3c71: "Contact 2:",
    auto_20_1169bd4a: "Subject for this subscription:",
    auto_20_87832da3: "serviceCenterId",
    auto_200_eab01883: "Rejected",
    auto_201_cc0c52e0: "Local file upload",
    auto_20160_ba633b06: "Agree",
    auto_202_cfbe45e7: "Take photos / videos",
    auto_203_47c45527: "Suggested handling method:",
    auto_203_959b08b8: "Please select a rating",
    auto_204_38baf24a: "Very dissatisfied",
    auto_204_c403a5e0: "Select suggested handling method",
    auto_205_a42c243e: "Dissatisfied",
    auto_205_d8e5327e: "Initial Diagnosis Processing Method",
    auto_206_317e891f: "Fair",
    auto_206_802db140: "Select initial visit handling",
    auto_207_73349dba: "Actual Processing Method",
    auto_207_a2abe9ff: "Satisfied",
    auto_208_7f46aae8: "Select actual handling method",
    auto_208_bf9129ea: "Very satisfied",
    auto_209_1ad3f865: "We welcome your feedback",
    auto_209_7a3032f3: "Select actual handling method",
    auto_21_92f76fe3: "serviceCenterName",
    auto_21_d819bfd8: "Subject for this cancellation:",
    auto_210_c7bb407f: "Actual fault type:",
    auto_210000513_5078ee96: "Log statistics start time: November 21, 2022",
    auto_211_9123b491: "Select fault classification",
    auto_212_03d121d3: "Score details",
    auto_212_71196810: "Test description",
    auto_213_c905215d: "Enter inspection result (max 400 characters)",
    auto_214_788c4e7e: "Inspection Result",
    auto_215_a3a60d9e: "Inspection images / videos",
    auto_216_fda9439e: "Upload images / videos",
    auto_217_0b79ebf8: "Read fault description",
    auto_218_bde87180: "Agree",
    auto_219_0d425989: "Rejected",
    auto_22_71a84be6: "Learning machine account",
    auto_22_ca836920: "Subscription duration to deduct:",
    auto_221_4fe609e4: "Local file upload",
    auto_222_a26baab5: "Take photos / videos",
    auto_223_0fdb1e9c: "Suggested Handling Method",
    auto_224_6d36bd59: "Select suggested handling method",
    auto_225_eac1b90f: "Initial Diagnosis Processing Method",
    auto_226_281830e2: "Select first diagnosis method",
    auto_227_4de236d6: "Initial diagnosis description",
    auto_227_79173d00: "English",
    auto_228_9e8950ed: "Math",
    auto_228_a0a2b7b5: "Enter initial diagnosis notes (max 400 characters)",
    auto_229_06438c2d: "Chinese",
    auto_229_623ff621: " to get a new code.",
    auto_229_b388a4cb: "Initial diagnosis result",
    auto_23_5eccdf82: "learningArea",
    auto_23_67c3b1f5: "Subscription duration to return:",
    auto_230_4952764d: "Subject",
    auto_230_79138e95: "Estimated completion time",
    auto_231_6b85c456: "Spring final exam",
    auto_231_89c25eb2: "Initial diagnosis images / videos",
    auto_232_0ecfdfec: "Factory Return Express Information",
    auto_232_cbe7d02c: "Fall midterm exam",
    auto_233_410a70dc: "Upload images / videos",
    auto_233_4fc7a003: "Score improvement",
    auto_234_3cfbcbdf: "Parent-facing handling method:",
    auto_234_6c77e952: "Total valid foundation duration",
    auto_234_b92bb886: "Save",
    auto_235_8a4c4bb7: "Rank",
    auto_235_df8798a9: "Select after-sales method",
    auto_236_74a41eaf: "Score",
    auto_236_b492118c: "New device SN for parent:",
    auto_237_60e436d2: "Enter new device SN",
    auto_237_bddc5b89: "Subject",
    auto_238_88c9b290: "Suggested Handling Method",
    auto_238_8aa4d192: "Foundation Effective",
    auto_239_2011eb2e: "Completion status",
    auto_239_572dbdf7: "Select suggested handling method",
    auto_24_be4e3997: "generalAvailableDuration",
    auto_24_cfa4dd68: "month",
    auto_240_107ef516: "Actual Processing Method",
    auto_240_6e635316: "Performance score",
    auto_241_a7c191fd: "Numeric value",
    auto_241_c0807481: "Select actual handling method",
    auto_242_35bd356d: "Score",
    auto_242_a36f8021: "SN code:",
    auto_243_e3477f5f: "Enter SN code",
    auto_243_ffa5de49: "Hours",
    auto_244_4144d920: "Hours",
    auto_244_8afebfce: "Repair Amount Original Price",
    auto_245_b99f79ba: "Discount",
    auto_245_e36e402a: "Completed",
    auto_246_721fbde9: "Incomplete",
    auto_246_762a0a77: "Total repair amount",
    auto_247_24d7527d: "Repair QuotationDownload",
    auto_247_cc41d671: "Question count",
    auto_248_1ee0cfc4: "Full score",
    auto_248_ee3fba3a: "Payment",
    auto_249_780e6b9b: "Rejected",
    auto_249_87dcabb7: "Accuracy",
    auto_25_863b5b8e: "areaDuration",
    auto_250_1ca1a70f: "Declined repair (return)",
    auto_250_4ace5df9: "Full score",
    auto_251_31b81bd5: "Foundation completion progress",
    auto_251_7ce21dc7: "If you dispute the repair quote, contact support; rejecting repair may affect device handling.",
    auto_252_30e634c3: "WeChat Pay QR codes are valid for 2 hours. If the QR code has expired, tap Pay again to get a new one.",
    auto_252_5bb13c93: "Full score",
    auto_253_08309e32: "WeChat Payment Recommended",
    auto_253_3b43b9b0: "Poster container element not found",
    auto_254_8a43e66e: "Failed to generate image",
    auto_254_cd68e88a: "Support credit card payment",
    auto_255_8cc3a952: "customerName",
    auto_255_90e9650e: "Use WeChat Pay",
    auto_256_e05908ce: "If the QR code has expired, tap ",
    auto_256_fb9dab74: "phoneNumber",
    auto_257_b27d66fa: "Refresh",
    auto_258_881fdc8a: "realNameAuth",
    auto_258_bb6cd229: "Get again",
    auto_259_9c2853a7: "Suggested Handling Method",
    auto_26_c4eea0dc: "agentId",
    auto_260_1fa1dfa2: "Select suggested handling method",
    auto_261_6e4da30e: "Actual Processing Method",
    auto_261_8ab57ee8: "Stage & grade",
    auto_262_06dc2702: "Select actual handling method",
    auto_263_13c93438: "Actual fault type",
    auto_263_bc2c70c1: "passStatus",
    auto_264_513d1204: "Select fault classification",
    auto_264_588a1075: "syncCourseStatus",
    auto_265_33c813d7: "Service staff",
    auto_265_f08753b4: "Non-warranty reason:",
    auto_266_5bf5f7c5: "Select non-warranty reason",
    auto_266_b63501b3: "learningMachineAccount",
    auto_267_9f460522: "Repair Instructions",
    auto_267_b97ad3f6: "area",
    auto_268_88e2a405: "subscribeSubject",
    auto_268_939e0a95: "No.",
    auto_269_7a7810c0: "Repair Category",
    auto_27_b61fc526: "text3u",
    auto_27_d2bf4fe8: "agentName",
    auto_270_866f0b5a: "Repair Details",
    auto_2702_84722670: "Select actual handling method",
    auto_271_00597f11: "Repair amount",
    auto_272_b34f6e2c: "Repair amount",
    auto_273_52546a8d: "Payment description:",
    auto_274_d28a4ee8: "Enter payment description (max 400 characters)",
    auto_275_4945136b: "Payment result:",
    auto_276_b6d570db: "Pay",
    auto_277_c6c3e0e3: "Agree",
    auto_278_4d987287: "Rejected",
    auto_279_0c5e2bee: "Local file upload",
    auto_28_c95c1bcf: "Subject",
    auto_280_a435f985: "Take photos / videos",
    auto_281_90a430ff: "math",
    auto_281_d8d42434: "Actual Processing Method",
    auto_282_12e37cb8: "Select actual handling method",
    auto_282_20150756: "notHeld",
    auto_283_a0c37874: "Inspection images / videos",
    auto_283_e9cbeeea: "passHeld",
    auto_284_493a8502: "Quality inspection result",
    auto_284_f3168d65: "tempPassHeld",
    auto_285_e93fb901: "notRecommended",
    auto_285_fffa3009: "Quality inspection remark",
    auto_286_1b5ad69d: "Enter quality check remark (max 400 characters)",
    auto_286_f3878e5a: "learnable",
    auto_287_3425dcf8: "Quality inspection images / videos",
    auto_287_4ec7765a: "notLearnable",
    auto_288_0278db73: "Invite Transfer",
    auto_288_acbdb7f8: "Upload images / videos",
    auto_289_7cb946ef: "Add repair detail",
    auto_29_13d755f8: "Machine Subscribe Status",
    auto_292_544a569b: "ReadFault description",
    auto_294_bccbd499: "stageGrade",
    auto_298_9b7d5cf3: "Actual Processing Method",
    auto_299_6bf44d2b: "Select actual handling method",
    auto_3_3c8a512d: "checkFaceChangeLearningMachine",
    auto_3_5e466813: "Available subscription duration <= 3",
    auto_3_7cdf040b: "texteuq",
    auto_3_7ef232fe: "Submit Materials",
    auto_3_a4526aa1: "*WeChat Pay QR codes are valid for 2 hours. If expired, tap Pay again to get a new code.",
    auto_3_f3a61608: "Contact 3:",
    auto_30_66c32371: "Select agent",
    auto_30_6dc1caf9: "Recent Subscribe/Cancel Date",
    auto_300_15efe189: "Actual fault type",
    auto_301_c4f93f5e: "Select fault classification",
    auto_302_7e3fa6d5: "Non-warranty reason",
    auto_303_55d157e8: "stageGrade",
    auto_305_05bf4e85: "servicePerson",
    auto_31_6c5829a0: "Current Study End Date",
    auto_31_fb14aa99: "Product Name",
    auto_316_5747370f: "Repair description:",
    auto_317_c4d8c876: "*Please upload fault images and customer service chat records confirming factory return, or the application will not be approved.",
    auto_318_e5664070: "*You can reach customer service in the dealer mini program or dealer system.",
    auto_319_ca8fd6e8: "Agree",
    auto_32_5300778b: "WeChat Pay is recommended",
    auto_32_b73ee84e: "Unit Price",
    auto_32_de56ac7d: "Operation",
    auto_320_9a8115d0: "Rejected",
    auto_321_f3f42745: "Repair Order No:",
    auto_322_f62ecded: "Enter device SN / purchase order no",
    auto_323_21724802: "Product Type:",
    auto_324_1079117f: "First hardware activation time:",
    auto_325_1cd0fb06: "Hardware Activate Time:",
    auto_326_4dcbe91d: "Software Activate Time:",
    auto_327_af652602: "Dealer Info:",
    auto_328_455fdaa4: "Last repair time:",
    auto_329_f6b5c503: "Renewal effective time:",
    auto_33_1fd9eecb: "Quantity",
    auto_33_a236e8ce: "submitMaterial",
    auto_330_e440e0ab: "Ship Time:",
    auto_331_00f8b802: "Warranty valid until:",
    auto_332_0c473955: "Estimated fault category:",
    auto_333_0ac5f60b: "Effective foundation study time in last 180 days (hours)",
    auto_333_d5c04f90: "Please select estimated fault category",
    auto_334_78609b66: "Detailed Description:",
    auto_334_b6f21e2a: "Knowledge gaps closed in last 180 days (foundation)",
    auto_335_a582cb25: "Student score improvement in last 180 days",
    auto_335_e921ea31: "Please enter a detailed description (max 400 characters)",
    auto_336_c0d5b479: "Upload images / videos:",
    auto_336_fb423e6d: "First exam score in last 180 days",
    auto_337_1f51f868: "Audit Result:",
    auto_337_6fc65c2a: "Latest exam score in last 180 days",
    auto_338_2f7b8451: "Score change from first to last exam (180 days)",
    auto_338_7d752935: "Repair vendor:",
    auto_339_31f360f4: "Average score improvement (180 days)",
    auto_339_8572df53: "Please select application type",
    auto_34_a3e39357: "Learning machine account",
    auto_34_c7372f4b: "Amount",
    auto_340_0b74be28: "Suggested Handling Method:",
    auto_340_5a440d46: "Score stability in last 180 days",
    auto_341_4b651596: "Average exam score (180 days)",
    auto_341_8d46ee87: "Select suggested handling method:",
    auto_342_225d514e: "Score standard deviation (180 days)",
    auto_342_d35a428e: "Audit Remark:",
    auto_343_57dbe80e: "Enter audit remark (max 400 characters)",
    auto_344_bb55a52a: "Agree",
    auto_345_0957f1aa: "Rejected",
    auto_346_0908e2d5: "Local file upload",
    auto_347_15d41886: "Take photos / videos",
    auto_348_f9768426: "Actual Processing Method",
    auto_349_cc32882e: "Select actual handling method",
    auto_35_06c71e3d: "dealerId",
    auto_35_940b0b37: "Pay Serial No.",
    auto_350_f2fc58e4: "Actual fault type",
    auto_351_0e2c4c06: "Select fault classification",
    auto_351_c6b73e7a: "Suggested handling method:",
    auto_352_98d4b1ac: "Return Result",
    auto_353_0a993491: "Express Company",
    auto_354_199b57b5: "Select express company",
    auto_355_e23b1694: "Express No.",
    auto_356_19d6bce9: "Enter express no.",
    auto_357_7d0cefcc: "Return images / videos",
    auto_358_85225a33: "Upload images / videos",
    auto_359_47a2c2df: "Repair Amount Original Price",
    auto_36_7fe79402: "dealerName",
    auto_36_8ef52a37: "Pay Method",
    auto_36_abfdc9c9: "Repair result:",
    auto_360_ddcd3bef: "Discount",
    auto_361_b53ab372: "Total repair amount",
    auto_362_2f99307c: "Repair QuotationDownload",
    auto_363_1fa20160: "Agree",
    auto_364_3892d1b5: "Rejected",
    auto_365_22d8e02c: "Suggested Handling Method",
    auto_366_dc6be558: "Select suggested handling method",
    auto_367_9e5d1345: "Actual Processing Method",
    auto_368_99d9acb0: "Select actual handling method",
    auto_369_2de8cffa: "Actual fault type",
    auto_37_b298f65c: "Pay Time",
    auto_37_efc28e26: "studentAccount",
    auto_370_cd112b3f: "Select fault classification",
    auto_371_a50c5719: "Non-warranty reason",
    auto_372_430d63b6: "Select non-warranty reason",
    auto_372_9a3c1d7d: "Total repair amount",
    auto_373_9334412f: "sNma",
    auto_374_48ca1fa7: "Enter SN code",
    auto_375_bc903cbb: "Repair Details",
    auto_376_21af678e: "Math",
    auto_376_e8e7b1b1: "No.",
    auto_377_4bc8c6b9: "All",
    auto_377_51e94756: "Repair Category",
    auto_378_087b51d3: "Student study duration daily report",
    auto_378_c18dccdf: "Repair Details",
    auto_379_3295bba5: "Repair amount",
    auto_38_5dc15e20: "studentName",
    auto_38_7c7db366: "Pay Amount",
    auto_380_0eae7322: "Math",
    auto_380_6326e534: "Repair amount",
    auto_381_769fd351: "Suggested Handling Method",
    auto_381_881fe582: "All",
    auto_382_10ff1bd1: "Select suggested handling method",
    auto_382_53fb76b8: "Student study duration weekly report",
    auto_383_8ba4344d: "Actual Processing Method",
    auto_383_e6592468: "All",
    auto_384_d0647bff: "Select actual handling method",
    auto_385_e8918b8d: "Actual fault type",
    auto_386_0f690b76: "Select fault classification",
    auto_387_a572d6f2: "sNma",
    auto_388_86557d8e: "Enter SN code",
    auto_389_106ff316: "Repair Instructions",
    auto_39_981a562a: "serviceCenterId",
    auto_39_f8adeb50: "Operator",
    auto_390_f010e885: "Enter repair instructions (max 400 characters)",
    auto_391_257f1d36: "Repair result",
    auto_4_1affe025: "Non-warranty reason:",
    auto_4_848fbce8: "Withdraw Application",
    auto_40_616e090e: "Dispatch Date",
    auto_40_71354afd: "serviceCenterName",
    auto_403_cfdb95d6: "Subject",
    auto_404_df63901a: "Machine Subscribe Status",
    auto_405_d42d266b: "Current cutoff date",
    auto_406_8bcdf4a4: "Important: To calculate and compare grade-wide results in a consistent and fair manner, before statistics on average score gain in the last 180 days, average exam score in the last 180 days, and score standard deviation in the last 180 days, each student's exam scores are converted using a standardization procedure to a unified 100-point scale.",
    auto_407_aa45471f: "Overall Analysis of Student Score Improvement",
    auto_408_85cbea7f: "Collapse",
    auto_409_c74e2fe2: "Expand",
    auto_41_9920dff0: "applicationNote",
    auto_41_f852f988: "Express Company",
    auto_410_8f7838e4: "Important: To calculate and compare grade-wide results in a consistent and fair manner, before statistics on average score gain in the last 180 days, average exam score in the last 180 days, and score standard deviation in the last 180 days, each student's exam scores are converted using a standardization procedure to a unified 100-point scale.",
    auto_411_f630a136: "Repair Quotation",
    auto_412_fd56053a: "Service PersonName",
    auto_413_f7669bb3: "Last Edit Time",
    auto_414_057d9acb: "Last Edited By",
    auto_415_22dcce77: "Please set query conditions first",
    auto_42_bdc73ed5: "Express No.",
    auto_42_db2651d9: "newStudentName",
    auto_426_67419378: "No tracking info yet",
    auto_427_942e6019: "Pass",
    auto_428_d0383398: "Long term",
    auto_429_91696a48: "Total Score",
    auto_429_92e861db: "Short term",
    auto_43_3ae78086: "Logistics Status",
    auto_43_ff2ef6b5: "newStudentFacePhoto",
    auto_430_6ca0eb76: "geSubjectzong ti fen",
    auto_430_947eb541: "Long term",
    auto_431_0bdf2f07: "Foundation",
    auto_431_4c90514a: "Short term",
    auto_432_68944296: "Valid Durationfen",
    auto_432_e0aaf07a: "Report",
    auto_433_72267377: "Report",
    auto_433_9a2d44cd: "System performance score",
    auto_434_99402a59: "text100text",
    auto_434_edc2c553: "Track",
    auto_435_fbe7801b: "Track",
    auto_435_fd6be6e4: "Cross-grade compensation factor: 1225 fall midterm score after compensation",
    auto_436_69c3e358: "Pass",
    auto_436_e6d00004: "SubjectFoundation60h",
    auto_437_27cd212a: "ti fenScorebu ji ru zui zhong de pai ming ji suan",
    auto_437_ad9a62b2: "Page sizeFrontend hardcoded firstshi ji",
    auto_438_62acb843: "Load failed",
    auto_438_bba362ca: "Foundation Effectivefen man fen100fen",
    auto_439_934cfbdf: "Statistics period: Jul 10–Aug 31, 2025",
    auto_439_f1a47351: "Chinese",
    auto_44_22854a73: "proofMaterial",
    auto_44_2fde8375: "Send Qty",
    auto_440_2d7949dd: "English",
    auto_440_e470f698: "xi tong biao xian fen man fen20fen",
    auto_441_33ffd6ef: "Chinese",
    auto_441_638f0ef4: "Statistics period: Jul 10–Aug 31, 2025",
    auto_442_6f7a8f7e: "English",
    auto_442_cc42a56e: "No rank",
    auto_443_44dd07d6: "Unfortunately, during this activity (Jul 10–Aug 31, 2025) no foundation course was taken",
    auto_443_ba4c8a8b: "Learning sessions",
    auto_444_2f090940: "Gift",
    auto_45_0070c41a: "studentAccount",
    auto_45_fff8ea33: "Charge Item",
    auto_452_0ffc43ee: "Service duration",
    auto_453_5d03913f: "Call Duration",
    auto_454_c079befc: "Service duration",
    auto_455_c641fa42: "Call Duration",
    auto_456_f0368aa0: "Cash Account",
    auto_457_055f7a2e: "remainingPayment",
    auto_458_256c6775: "Pay Method",
    auto_459_edcab6b9: "Apply Transfer to Service Center",
    auto_46_5e69feaa: "Unit Price",
    auto_46_c38e83ce: "studentName",
    auto_460_635091c6: "Adaptive Account",
    auto_460522_c46627d1: "Repair description",
    auto_461_42ffa4f6: "Enter adaptive account",
    auto_462_77ac7212: "User Name",
    auto_463_866ca1be: "Current service center ID",
    auto_464_b6bc3e36: "Current service center name",
    auto_465_e4f28096: "New device SN",
    auto_466_417ab7f4: "Initial diagnosis images / videos",
    auto_467_212fe736: "Inspection images / videos",
    auto_468_70d1a468: "Quality inspection images / videos",
    auto_469_6e3e8cfa: "Return images / videos",
    auto_47_3f310da6: "Learning machine account",
    auto_47_702b7486: "Quantity",
    auto_470_b4b3c003: "Payment QR codes are valid for 2 hours. If expired, contact your dealer or customer service to get a new code.",
    auto_471_ce1859e8: "Customer ID",
    auto_472_e66c9649: "1. Please pay within 2 business days. Otherwise the device will be treated as not requiring repair and will be returned unrepaired.",
    auto_473_6a6a65c2: "2. If repair is impossible due to missing parts or best-effort limits, the original repair fee will be refunded; we assume no further liability.",
    auto_474_919d675a: "3. After repair is completed, from the date we notify you, our repair center will store your device free of charge for 1 month; overdue pickup is not allowed beyond that period.",
    auto_475_0bccafc0: "Out-of-warranty repair incurs a fee. Please go to Service Center - Repair Management.",
    auto_476_e3048df8: "Repair payment",
    auto_477_231a7700: "Out-of-warranty repair is required and may incur a fee. Please complete the steps in Service Center.",
    auto_478_d99e06c9: "Repair Management",
    auto_479_7f349b2d: "Repair payment",
    auto_48_76602ef3: "Amount",
    auto_48_9304b4af: "agentId",
    auto_480_828e6717: "1. Whole machine replacement: The entire set (device, all accessories and packaging) must be returned together. If any accessories are missing, you will need to resend them at your own expense.",
    auto_481_a786a76b: "2. Shipping requirement: For devices within normal warranty, please use SF Express collect (select basic insurance of 1000). Other couriers are not accepted for collect shipping.",
    auto_482_e92ab4dc: "3. Please pack the device or accessories properly to avoid damage during transit. Damage caused by improper packaging will require paid repair.",
    auto_483_928fe8ab: "1. Please mail the device to the service center. Contact info:",
    auto_484_966e41e2: "2. After mailing, please go to Service Center - Repair Management.",
    auto_485_ab50f737: "Return shipping",
    auto_486_d6b480e5: "Are you satisfied with this repair service?",
    auto_487_007ca415: "Submit",
    auto_488_b29e261f: "Evaluate",
    auto_489_ddfa90d4: "Enrolled student list",
    auto_49_2585ba0c: "Discount",
    auto_49_6bfd048e: "agentName",
    auto_490_afc260cf: "Activity Rules",
    auto_491_6e4b2373: "View ranking",
    auto_492_9435e1c2: "Recharge Area Duration",
    auto_493_c261b541: "Recharge Universal Duration",
    auto_494_f48698f1: "Withdraw Application",
    auto_495_019f0951: "Supervisor Status",
    auto_496_a098bf4b: "Supervisor Status",
    auto_497_af42befc: "Data note: Data may be delayed by up to 1 hour. For data definitions, please go to Help Center.",
    auto_499_ce0718ea: "Detail",
    auto_5_058edb1d: "Select non-warranty reason",
    auto_5_2642db25: "Repair amount",
    auto_5_971e3864: "Unsubscribe Effective",
    auto_5_ccf0b2ca: "Reject",
    auto_5_f178aefd: "text7wz",
    auto_50_2ebed531: "Back",
    auto_50_a903f791: "Right Name",
    auto_500_a828735f: "Distribution Time is required. Other functions are available only after a distribution time is selected. Please select a distribution time within the current day range of one month.",
    auto_501_48092518: "Export",
    auto_502_1e1de5f1: "Modify Area",
    auto_503_51e1995f: "After freezing, subscription duration in this account cannot be used",
    auto_504_4f36b366: "Export",
    auto_505_7ee80f77: "pi liangDownloadzheng shu",
    auto_507_3a10ccc6: "Operation",
    auto_508_04104a66: "batchAssignServicePerson",
    auto_509_28f98467: "jin180Daily Student Score Improvement Analysis",
    auto_51_3a73d270: "Applicable Product",
    auto_51_e10d28d3: "For prototype subscription card accessories, please select HQ delivery",
    auto_510_3b232c96: "Exportshu ju",
    auto_511_48a81cbb: "Data note: data is updated daily at 9:00 AM. For definitions, please go to",
    auto_512_8a1c00e3: "Supervisor Status",
    auto_52_1a757eb0: "Expiry Time",
    auto_52_3e45d83a: "Change dispatch type to HQ delivery?",
    auto_53_26611724: "This limited model: please select HQ delivery",
    auto_53_9b30d563: "Right Code",
    auto_534_729c0a98: "Repair amount",
    auto_54_18949a2d: "Change dispatch type to HQ delivery?",
    auto_54_acf748ec: "Store receipt",
    auto_55_49aa702e: "Main warehouse",
    auto_55_c47ac8b0: "For learning devices, smart pens, etc., select regional agent for shipping.",
    auto_558_de3ba6e7: "Select suggested handling method",
    auto_56_585eb833: "Store receiving",
    auto_56_846572c6: "Change dispatch type to regional agent delivery?",
    auto_57_52a50233: "Are you sure you want to delete?",
    auto_57_d944fc10: "Enterxiang xiDelivery Addressli",
    auto_5719_861a1057: "Non-warranty reason:",
    auto_58_3f4e6ee4: "Purchase Order No.",
    auto_58_e09984a9: "Select agent",
    auto_59_33616ce3: "Product Name",
    auto_59_65f26a9f: "Purchase Unit",
    auto_6_5b16954e: "Unsubscribe",
    auto_6_7a1f1b69: "Select non-warranty reason",
    auto_60_9be5101c: "Unit Price",
    auto_60_9ee15081: "Purchase Unit",
    auto_6003001_02a744ab: "stageGrade",
    auto_6003002_877902ff: "stageGrade",
    auto_6003003_364f8301: "stageGrade",
    auto_6004001_e10db50f: "stageGrade",
    auto_6004002_0865167a: "stageGrade",
    auto_6004003_b91584c0: "stageGrade",
    auto_6004004_5b8f673d: "stageGrade",
    auto_6004005_54bfd328: "stageGrade",
    auto_6004006_6df46f26: "stageGrade",
    auto_6004007_0cb97568: "stageGrade",
    auto_6004008_8cb729ce: "stageGrade",
    auto_6004009_67a799aa: "stageGrade",
    auto_6004010_a35dd9bd: "stageGrade",
    auto_6004011_dac05942: "stageGrade",
    auto_6004012_ca4537e1: "stageGrade",
    auto_6004013_061a6c58: "stageGrade",
    auto_6004020_9fb52f98: "stageGrade",
    auto_6004024_56050475: "stageGrade",
    auto_6004025_a2790b71: "stageGrade",
    auto_61_19561ec4: "Quantity",
    auto_61_6a47425d: "Created By",
    auto_62_183c5153: "Amount",
    auto_62_ea1fd711: "Remark",
    auto_63_01613afe: "Enter remark (max 200 characters)",
    auto_63_33c01edb: "Pay Serial No.",
    auto_64_3b8387c1: "Custom Discount Amount",
    auto_64_9f188f91: "Pay Method",
    auto_65_684b34d9: "Enter custom discount amount",
    auto_65_e6f5f651: "Pay Time",
    auto_66_64fdfb77: "SelectAdd Goods",
    auto_66_fdba32b0: "Pay Amount",
    auto_67_a43a4a56: "Operator",
    auto_67_e4534610: "Goods Detail",
    auto_68_399f575c: "Dispatch Date",
    auto_68_ebd45720: "Delete",
    auto_69_29f94f29: "Express Company",
    auto_69_fd2821fc: "Payment Detail",
    auto_7_04ce20b4: "Suggested handling method:",
    auto_7_06d7f018: "*If you dispute the repair quote, contact customer service promptly; if you reject repair, the manufacturer will return the device.",
    auto_7_24eae4ed: "Your monthly quota usage is within the limit. No application is required; you may transfer students in directly.",
    auto_7_48789045: "Enter SN code",
    auto_7_4bc804a5: "Subscribe",
    auto_70_736b7933: "Prepaid Freight Detail",
    auto_70_9406d319: "Express No.",
    auto_71_06c824a3: "Logistics Detail",
    auto_71_1ce95229: "Logistics Status",
    auto_72_1f5e0a58: "Send Qty",
    auto_73_5a28bf46: "Charge Item",
    auto_73_70dbabd2: "Content",
    auto_73_f7ef2a1e: "Purchase Amount",
    auto_735_65180f3b: "Repair category",
    auto_74_416952d0: "Save",
    auto_74_69d68a8d: "Unit Price",
    auto_75_bee9082e: "Save & Pay",
    auto_75_fafdc271: "Quantity",
    auto_76_3fc37ef1: "For prototype subscription card accessories, please select HQ delivery",
    auto_76_a732542a: "Select fault classification",
    auto_76_ba853d4f: "Amount",
    auto_77_13dfff6e: "Change dispatch type to HQ delivery?",
    auto_77_326b6100: "Discount",
    auto_77_df26ef91: "Total repair amount",
    auto_78_cd7bfcc4: "For learning tablet, smart stylus and other full-price products, please select regional master franchisee delivery",
    auto_78_f412d8c2: "Store receiving",
    auto_79_c325b4aa: "Change dispatch type to regional agent delivery?",
    auto_79_dc062f24: "No application information",
    auto_8_0518f833: "Unsubscribe Effective",
    auto_8_1fd88c87: "Enter payment notes (max 400 characters)",
    auto_8_2f854118: "Your cross-entity device students have exceeded the maximum allowed by headquarters. Transfer is not permitted.",
    auto_80_9a7d8dda: "Pending",
    auto_80_a0a4046f: "Tip",
    auto_81_b96fa279: "Are you sure you want to delete?",
    auto_81_ead4d6ba: "Rejected",
    auto_82_584d7703: "Tip",
    auto_82_e97486ea: "Passed",
    auto_83_04f546f7: "Purchase Order No.",
    auto_83_7c03422b: "Attachment",
    auto_83_8f5338a9: "Agreement images",
    auto_84_724cbd8c: "Purchase Unit",
    auto_84_f3a42535: "Start Date",
    auto_85_6ca0f371: "End Date",
    auto_85_7fa04e5d: "Purchase Unit",
    auto_86_195870b1: "Created By",
    auto_86_1dc00c5a: "Preview",
    auto_87_37398fc9: "Purchase type",
    auto_87_8f7f1a88: "Application type",
    auto_88_0f7b6792: "Application validity period",
    auto_88_b04a7574: "Select purchase type",
    auto_885_71a4f1a4: "Enter repair description (max 400 characters)",
    auto_89_56d260b6: "Shipment Region Agent",
    auto_89_6a3150fb: "Application time",
    auto_9_32922692: "Confirm",
    auto_9_5429858c: "Please upload proof that the child using the tablet is from the same household. JPG/PNG supported, max 20MB per file.",
    auto_9_b8e50bf2: "You can upload at most 9 images or videos.",
    auto_9_d59fe97e: "No application is required in the current status, or submission is not allowed.",
    auto_90_124fbfdc: "Declarant",
    auto_90_dfdce47a: "Consignee",
    auto_91_2aac4e29: "Receiver Phone",
    auto_91_7e8833e7: "Application status",
    auto_916_2233ebaf: "Upload image",
    auto_92_51c9c127: "Operation",
    auto_92_fb3a2700: "Province/City/District",
    auto_93_2806a664: "Application detail",
    auto_93_8fbb42a4: "Dispatch Type",
    auto_93438_a86b9958: "Actual fault type:",
    auto_94_6703c8bb: "Declaration",
    auto_94_6e065e4b: "Select dispatch type",
    auto_94756_d52a8e4d: "Repair category",
    auto_95_4ebaf41d: "Pending",
    auto_95_829a762a: "Shipment Region Agent",
    auto_95_c8654dd5: "No.",
    auto_96_891981ef: "Application successful",
    auto_96_a8f51346: "Agent Warehouse",
    auto_97_4b83a8c3: "Audit Reject",
    auto_97_9b94a9cf: "Agent Warehouse",
    auto_98_9cae1144: "Select agent warehouse",
    auto_98_9fc5b955: "Submit again",
    auto_99_7e4f7bcf: "Delivery Address",
    auto_99_f3974dc0: "Holiday full-time",
    avgUpScore: "Average Score Improvement (Last 180 Days)",
    back: "After mailing, please ",
    balance: "Area Duration (Gift/Renewal) Balance",
    batchAllocatedCustomerAccountUser: "Learning Center Account",
    batchAllocatedCustomerServerPeople: "Service Person",
    batchAllocatedCustomerStageGrade: "Stage/Grade",
    batchAllocatedCustomerStudentName: "Name",
    batchAllocatedCustomerTitle: "Batch Assign Service Person",
    batchAssignServicePerson: "Batch Assign Service Person",
    batchAssignServicePerson508: "Batch Assign Service Person",
    bayear: "Grade 8",
    bgImageLoading: "Background image loading, please wait",
    bindConfirmTip1: "1. Student {name} ({account}) is already bound to another machine account.",
    bindConfirmTip2: "2. Confirm to rebind student {name} ({account}) to current machine account?",
    bindConfirmTip3: "3. After rebind, subscribed subjects ({subjects}) will be unsubscribed, and deducted duration will not be refunded.",
    bindFailed: "Bind failed",
    bindStudentAccount: "Bind Student Account",
    bindSuccess: "Bind successful",
    birthDate: "Birth Date:",
    boundAccountCount: "Bound Account Count",
    byAnalyst: "By Analyst",
    byGrade: "By Grade",
    callDuration: "Call Duration",
    callEndTime: "Call End Time",
    callStaff: "Call Staff",
    callStaffAccount: "Call Staff Account",
    callStaffName: "Call Staff Name",
    callStartTime: "Call Start Time",
    callTime: "Call Time",
    campus: "Campus",
    campusName: "Campus Name",
    cancel: "Cancel",
    cancelFailed: "Cancel failed",
    cancelOrderConfirmText: "Confirm to cancel this order? Once cancelled, the paid amount will be refunded to the corresponding agent account and the futures order quota will be adjusted.",
    cancelShutdown: "Cancel Shutdown",
    cancelSubscribe: "Cancel Unsubscribe",
    cancelSuccess: "Cancelled successfully",
    cancelUnsubscribe15: "Cancel Unsubscribe",
    cannotUnbindNotExceedLimit: "Cannot unbind. Account bind limit not exceeded.",
    caozuo: "Operator",
    certAreaMismatchTip: "New cert area does not match common area.<br/>After modification, gift subscription duration cannot be used this month. Confirm to modify?",
    certAreaNotExist: "Machine account cert area not set. Please complete cert area first.",
    changeStudentPassword: "Change Student Password",
    changeSupervisorStatus: "Change Supervisor Status",
    currentSupervisorStatusLabel: "Current Supervisor Status: ",
    analystLabel: "Analyst: ",
    noAnalyst: "None",
    removeAnalystTip: "(To remove the student's analyst, please set the supervisor status to \"No Supervision\" in the \"Change Supervisor Status\" operation above)",
    changeType: "Change Type",
    changeTypeActivate: "Activate",
    changeTypeChangeArea: "Change Area",
    changeTypeExtraGift: "Extra Gift",
    changeTypeGift: "Gift",
    changeTypeGiftRenew: "Gift Renew",
    changeTypeOnePersonOneReturn: "One Person One Return",
    changeTypeOpenSubscribe: "Open Subscribe",
    changeTypeRenew: "Renew",
    changeTypeSubscribe: "Subscribe",
    changeTypeWrongReturn: "Wrong Subscribe Return",
    checkFaceChangeLearningMachine_1: "Request parameters cannot be empty",
    checkFaceChangeLearningMachine_2: "Change too frequent, cannot change account phone number",
    checkFaceChangeLearningMachine_3: "Only learning machines with verified accounts can change phone number. Please complete face verification first.",
    checkFaceChangeLearningMachine_networkError: "Network error, please try again later",
    chemistry: "Chemistry",
    chinese: "Chinese",
    chuangjian: "Creator",
    ci: "Next Follow",
    cityLevel: "City Level",
    cityLevelLabel: "City Level:",
    clearanceCycleDays: "Clearance Cycle (Days)",
    clearanceTime: "Clearance Time",
    clearFilter: "Clear filter",
    clickUpload: "Click to Upload",
    closeAutoRenewal: "Close Auto Renewal",
    closeAutoRenewalConfirm: "Close Auto Renewal",
    closeAutoRenewalTip: "Close auto renewal? Service will not auto-renew after expiry.",
    closeFailed: "Close failed",
    closeSuccess: "Closed successfully",
    coinMall: "Coin Mall",
    collectCount: "Collection Count",
    commonArea: "Common Area",
    commonAreaLabel: "Common Area:",
    complete: "Completed",
    completePaymentWithin: "] page to view the repair quotation details and choose whether to pay. If you have any objections, please contact customer service promptly.",
    confirm: "Confirm",
    confirm2: "OK",
    confirmFreezeAccount: "Confirm to {action} account {account}?",
    confirmModify: "Confirm",
    confirmUnbind14: "Confirm to unbind?",
    confirmUnbind15: "Are you sure you want to unbind the student from the service center?",
    confirmUnsubscribe: "Confirm to unsubscribe?",
    confirmUnsubscribe12: "Confirm to unsubscribe?",
    confirmWithdrawApply: "Confirm to withdraw this application?",
    confirmWithdrawApply13: "Confirm to withdraw this application?",
    contact: "Contact",
    contact1: "Contact 1:",
    contact2: "Contact 2:",
    contact3: "Contact 3:",
    contactInfo: "Contact",
    correctNewSNCode406: "Correct New SN Code",
    correctNewSNCode415: "Correct New SN Code",
    correctRate: "Correct Rate",
    correctRateOrScoreRate: "Correct rate (or score rate)",
    courseName: "Course Name",
    courseType: "Course Type",
    courseTypeFormal: "Formal course",
    courseTypeFormalRetake: "Formal course retake",
    courseTypeFoundation: "Foundation",
    courseTypeFoundationDowngrade: "Foundation downgrade",
    courseTypeFoundationRetake: "Foundation retake",
    courseTypeFoundationUpgrade: "Foundation upgrade",
    courseTypeRetake: "Retake",
    courseTypeSyncStudy: "Synchronous study",
    createTime: "Create Time",
    crossEntityApplyStatus: "Application Status",
    crossEntityApplyStatusApproved: "Approved",
    crossEntityApplyStatusPending: "Pending Review",
    crossEntityApplyStatusRejected: "Review Rejected",
    crossEntityApplySuccess: "Cross-entity supervision application submitted",
    crossEntityAuditor: "Auditor",
    crossEntityAuditTime: "Audit Time",
    crossEntityDealerId: "Device Dealer ID",
    crossEntityDealerName: "Device Dealer Name",
    crossEntityDevice: "Your Cross-entity Device Student Has",
    crossEntityDialogAuditOptionApprove: "Approved",
    crossEntityDialogAuditOptionReject: "Rejected",
    crossEntityDialogAuditRemarkPlaceholder: "Enter audit comments",
    crossEntityDialogAuditResult: "Audit result",
    crossEntityDialogAuditStatus: "Audit status",
    crossEntityDialogBtnCancel: "Cancel",
    crossEntityDialogBtnClose: "Close",
    crossEntityDialogBtnSubmitApply: "Submit application",
    crossEntityDialogBtnSubmitAudit: "Submit review",
    crossEntityDialogClickUploadImage: "Click to upload image",
    crossEntityDialogGuideLine1: "When the device purchased by the student is not under your same-entity dealer, the student is supervised across entities.",
    crossEntityDialogGuideLine2: "To transfer such students for service, submit for review and wait for provincial approval before transfer.",
    crossEntityDialogProofDocuments: "Supporting documents",
    crossEntityDialogProofImageAlt: "Supporting document",
    crossEntityDialogRuleAuditRemark: "Please enter audit comments",
    crossEntityDialogRuleAuditResult: "Please select audit result",
    crossEntityDialogRuleDescriptionLength: "Situation description must be 5–200 characters",
    crossEntityDialogRuleDescriptionRequired: "Please enter situation description",
    crossEntityDialogRuleEvidence: "Please upload supporting documents",
    crossEntityDialogRuleStudentAccount: "Please enter student account",
    crossEntityDialogSelectAuditResult: "Select audit result",
    crossEntityDialogSituationDescription: "Situation description",
    crossEntityDialogSituationPlaceholder: "Enter situation description (5–200 characters)",
    crossEntityDialogStudentAccountPlaceholder: "Enter student account",
    crossEntityDialogTitleAudit: "Review cross-entity supervision application",
    crossEntityDialogTitleCreate: "New cross-entity supervision application",
    crossEntityDialogTitleFallback: "Cross-entity supervision application",
    crossEntityDialogTitleView: "Cross-entity supervision application details",
    crossEntityDialogTransferServiceCenterId: "Transfer-in service center ID",
    crossEntityDialogTransferServiceCenterName: "Transfer-in service center name",
    crossEntityDialogUploadProofHint: "Upload proof of supervision service purchase and communication records with parents",
    crossEntityStudentAccount: "Student Account",
    crossEntityStudentName: "Student Name",
    crossEntityStudentNameAccount: "Student Name / Account",
    crossEntitySubmitter: "Submitter",
    crossEntitySubmitTime: "Application Submit Time",
    crossEntitySupervisionQuotaArea: "Area",
    crossEntitySupervisionQuotaCurrentUsedLimit: "Current dealer used quota",
    crossEntitySupervisionQuotaDealer: "Dealer:",
    crossEntitySupervisionQuotaDealerId: "Dealer ID",
    crossEntitySupervisionQuotaDealerName: "Dealer Name",
    crossEntitySupervisionQuotaDealerPlaceholder: "Please enter Dealer ID",
    crossEntitySupervisionQuotaExemptLimit: "Same-entity exempt quota",
    crossEntitySupervisionQuotaPeriod: "Statistics Period:",
    crossEntitySupervisionQuotaStudentCount: "Same-entity supervised student count",
    crossEntitySupervisionQuotaUpperLimit: "Same-entity upper quota",
    crossEntitySupervisionQuotaUsedLimit: "Same-entity used quota",
    currentCertArea: "Current Cert Area",
    currentCertAreaLabel: "Current Cert Area:",
    currentCommonAreaLabel: "Current Common Area:",
    currentServiceCenter: "Current Service Center:",
    currentServiceCenterId: "Current Service Center ID:",
    currentServiceCenterName: "Current Service Center Name:",
    currentStudyEndDate: "Current Study End Date",
    currentStudyEndDate31: "Current Study End Date",
    customDiscountExceedTotal: "Custom discount cannot exceed total price",
    customer: "Search Customer",
    customerName: "Customer Name",
    customerName255: "Customer Name",
    customerSubmitted: "Customer submitted",
    dailyKnowledgePointSelfStudyCount: "Daily knowledge point self-study count",
    danhao: "Repair Order No",
    dataDescription: "Data description",
    dataDescriptionByMonth: "Data description: Data updates on the 1st of each month. For data definitions, please go to Help Center",
    dataDescriptionDayDelay: "Data description: Data has 1-day delay, updated daily at midnight. For data definitions, please go to Help Center",
    dataDescriptionTip: "Data may have up to 1 hour update delay. For data definitions, please go to Help Center",
    date: "Date",
    dateLabel: "Date:",
    day: "Day",
    dayhour: "Log Statistics Start Time",
    ddjDurationInPeriod: "DDJ duration in period",
    ddjEffectAbnormal: "DDJ self-study effect abnormal:",
    ddjEfficiencyAbnormal: "DDJ self-study efficiency abnormal:",
    ddjValidStudyTime: "DDJ Valid Study Time (Last 180 Days)",
    dealer: "Dealer ID",
    dealerId: "Dealer ID",
    dealerId35: "Dealer ID",
    dealerIdLabel: "Dealer ID:",
    dealerName: "Dealer Name",
    dealerName36: "Dealer Name",
    dealerNameLabel: "Dealer Name:",
    deductDurationLabel: "Deduct Duration:",
    deleteSuccess: "Deleted successfully!",
    deliveryAddressLabel: "Delivery Address:",
    detail: "Detail",
    detail403: "Detail",
    detailedDescription413: "Detailed Description",
    details: "Details",
    detection397: "Detection",
    device: "Device SN Code",
    deviceDiagnosedByVendor: "Device has been diagnosed by the vendor",
    deviceDiagnosedByVendorNeedRepair: "Device has been diagnosed by the vendor and requires out-of-warranty repair",
    deviceRepairApplications: "device repair application(s)",
    deviceSNCode: "Device SN Code",
    deviceSNCodeLabel: "Device SN Code:",
    dialTime: "Dial Time",
    dianhua: "Recipient Phone",
    dili: "Geography",
    dingshiqu: "Subscription Duration Area",
    disableSuccess: "Disabled Successfully",
    discountAmount: "Discount Amount",
    dishu: "Foundation Building Count",
    displaySwitchDesc: "The display switch (will show in the pickup store when enabled)",
    disputeResult405: "Dispute Result",
    distributionTime: "Distribution Time",
    download: "Download",
    downloadElectronicCert: "Download E-Certificate",
    downloadEnrollmentPoster: "Download Enrollment Poster",
    downloadFailed: "Download failed",
    downloadSuccess: "Download successful",
    durationDetailHours: "Duration Detail (hours)",
    duxueStatusExpiring: "Supervision Expiring Soon",
    editCustomerArchive: "Edit Customer Archive",
    editFailed: "Edit failed",
    editSuccess: "Edited successfully",
    effectiveDurationHours: "Effective Duration (hours)",
    enableSuccess: "Enabled Successfully",
    english: "English",
    englishName: "English Name",
    enrollmentName: "Enrollment Name",
    enrollmentPosterFilename: "{userName}_enrollment_poster-{createTime}.png",
    enrollParent: "Enroll Parent",
    enrollTime: "Enroll Time",
    enterPhone: "Enter phone number",
    enterProductName: "Enter Product Name",
    enterSchool: "Enter school",
    er: "Payment QR Code Valid Period:",
    errorCategory: "Error Category",
    errorCount: "Error Count",
    errorRate: "Error Rate",
    eryear: "Grade 2",
    evaluate407: "Evaluate",
    evaluateServiceHere197: "Evaluate this service here",
    examScoreUpRate: "Exam Score Improvement Rate (Last 180 Days)",
    exchangeLearningMachine: "Exchange Learning Machine",
    exchangeMachineSN: "Exchange Machine SN",
    exchangePrice: "Exchange Price",
    exchangeSuccess: "Exchange successful!",
    expectedGiftHours: "Expected gift hours",
    expirationTime: "Expiration Time",
    export: "Export",
    exportFailRetry: "Export failed, please try again later",
    exportReport: "Export Report",
    faceRiskBaselinePhotoLabel: "Face reference photo",
    faceRiskCollectionMethodLabel: "Collection method",
    faceRiskCompareImageLabel: "Image",
    faceRiskLivenessMethodLabel: "Liveness detection method",
    faceRiskRecognitionSimilarityLabel: "Recognition similarity",
    factoryExpressNoLabel: "Shipment to factory",
    fastTrackBindNoAuditDesc: "After using this channel, account binding will be exempt from audit.",
    fastTrackNoAudit: "Fast Track No Audit",
    faultType411: "Fault Type",
    faultType412: "Fault Type",
    feedbackThanks: "Your feedback motivates us!",
    female: "Female",
    fen: "Liveness Score",
    fenlei: "Actual Fault Classification",
    fieldDescription: "Field Description",
    fileUploadingWait: "File uploading, please wait before submit",
    fill: "Fill",
    fillAddressStep: "Fill in Delivery Address",
    fillEnglishName: "Fill in Student English Name",
    fillExpressInfo: "] page to fill in your express info and return info.",
    fillQuotation398: "Fill Quotation",
    finalAbilityValue: "Final Ability Value",
    finalAvgAbility: "Final average ability",
    fiveStarCount: "5-Star",
    followContent: "Follow Content:",
    followContentPlaceholder: "Enter follow content",
    followStatusNoFollowNeeded: "No Follow Needed",
    followStatusNoLimit: "No Limit",
    followStatusPendingFollow: "Pending Follow",
    foundationCourseStudyDuration: "Foundation Course Study",
    foundationDuration: "Foundation",
    foundationEffectiveDuration: "Foundation Effective",
    foundationErrorCorrectionDuration: "Foundation Error Correction",
    foundationStudyDuration: "Foundation study duration",
    fourStarCount: "4-Star",
    freeze: "Freeze",
    freezeSubscriptionTip: "After freezing, subscription duration in this account cannot be used.",
    freezeSuccess: "Account frozen successfully",
    frozen: "Frozen",
    fulltime: "Full-time",
    fullTime: "Full-time:",
    fulltimeInfoIncompleteTip: "Please complete the student's school and grade information before applying.",
    fulltimeType1Tip: "(≥5 hours)",
    fulltimeType2Tip: "(≥25 hours)",
    gender: "Gender:",
    generalAvailableDuration24: "General Available Duration",
    generatingText: "Generating...",
    gengqu: "Change Area",
    giftedHours: "Gifted hours",
    giftFailed: "Gift failed",
    giftReason: "Gift Reason",
    giftSubscriptionBalance: "Gift Subscription Balance",
    giftSubscriptionCardUsage: "Gift Subscription Card Usage",
    giftSubscriptionDuration: "Gift Subscription Duration",
    giftSubscriptionDurationLabel: "Gift Subscription Duration",
    giftSubscriptionMonths: "Gift Subscription Months",
    giftSubscriptionType: "Gift Subscription Type",
    giftSuccess: "Gift successful",
    goDeclare: "Go to Declare",
    goNow: "Go Now",
    gotIt: "Got it",
    grade: "Grade",
    grantReason: "Grant Reason",
    grantUser: "Grant User",
    guinnessElectronicStatusHeader: "E-Certificate Status",
    guinnessElectronicStatusLabel: "E-Certificate Status:",
    guinnessEnglishNameLabel: "English Name",
    guinnessPaperStatusHeader: "Paper Certificate Status",
    guinnessPaperStatusLabel: "Paper Certificate Status:",
    guinnessStatusApplied: "Applied",
    guinnessStatusAppliedMaking: "Applied, In Progress",
    guinnessStatusCompleted: "Completed",
    guinnessStatusNotApplied: "Not Applied",
    guinnessStatusPaying: "Payment in Progress",
    guinnessStudentAccountHeader: "Student Account",
    guinnessStudentNameText: "Student Name",
    hao: "One Person One Number Return",
    hasBeenApproved: "has been approved.",
    healthDegree: "Health Degree",
    healthPersonCount: "Healthy Person-Courses",
    healthRate: "Health Rate",
    highActiveDuration: "High Active",
    highActiveEffectiveDuration: "High Active Effective",
    highActiveEffectiveRatio: "High Active Effective Ratio",
    highActiveRate: "High Active Rate",
    homeAddress: "Home Address:",
    homeAddressLabel: "Home Address:",
    homeAddressPlaceholder: "Enter home address",
    hour: "Subscription Duration Details",
    hourhour: "Muttering Usage Duration Report",
    hoursTipAreaMatch: "Common area matches cert area. Recommend area duration recharge.",
    hoursTipAreaMismatch: "Common area mismatches cert area. Recommend universal duration recharge.",
    hoursTipUniversal: "Universal duration available. Please select recharge type as needed.",
    houryici: "Use previous params",
    houryoubackyou: "choose whether to pay. If you have questions, contact customer service promptly. Thank you for your cooperation; our after-sales team will expedite handling.",
    hua: "Video Call Service",
    id: "ID",
    iKnow: "Got it",
    imageAddFailed: "Failed to add image",
    imageFormatJpgPngGifBmp: "Only JPG, JPEG, GIF, PNG, BMP format images allowed~",
    imageLoadFailCheckNetwork: "Image load failed, please check network",
    imageMax9Count: "Maximum 9 images allowed~",
    imageNoDuplicate: "Duplicate images not allowed~",
    imageSizeExceed5M: "Image size exceeds 5M limit~",
    imageSizeExceed8M: "Image size cannot exceed 8MB!",
    info: "Face 2 Most Similar Face Info",
    information: "Information",
    initialDiagnosis396: "Initial Diagnosis",
    invalidReason: "Invalid Reason",
    invalidReasonPlaceholder: "Within 100 characters",
    inviteStudentTransfer: "Invite Student Transfer",
    inviteTransfer: "Invite Transfer",
    jianli: "Suggested Handling Method",
    jie: "Recognition Result",
    jiuyear: "Grade 9",
    kaiding: "Open Subscription",
    kanshi: "Video Watch Duration (Inexact)",
    kexue: "Science",
    knowIt: "Got it",
    knowledgePointCode: "Knowledge Point Code",
    knowledgePointName: "Knowledge Point Name",
    knowledgePointNote: "Knowledge Point Note",
    lastExamDate: "Last Exam Date",
    learnable: "Learnable",
    learnable286: "Learnable",
    learningArea: "Learning Area",
    learningArea23: "Learning Area",
    learningAreaLabel: "Learning Area:",
    learningCenterAccount: "Learning Center Account",
    learningMachineAccount: "Learning Machine Account",
    learningMachineAccount266: "Learning Machine Account",
    learningMachineSNCode410: "Learning Machine SN Code",
    li: "Physics",
    lijie: "Repair Handling Result",
    linkedStudents: "Linked Students",
    liuyear: "Grade 6",
    loadFailed: "Load Failed",
    loadingText: "Loading...",
    long: "Long-term",
    ma: "SN Code:",
    machine: "Learning Machine Account",
    machineAccount: "Machine Account:",
    machineAccount22: "Machine Account",
    machineAccount34: "Machine Account",
    machineAccount47: "Machine Account",
    machineAccountCode: "Machine Account No.:",
    machineAccountLabel: "Machine Account:",
    machineAccountPhoneLabel: "Machine Account Phone:",
    machineRenewal: "Machine Renewal",
    machineSNCode: "Machine SN Code",
    machineSNCodeLabel: "Machine SN Code:",
    machineSubscribeStatus: "Machine Subscribe Status",
    machineSubscribeStatus29: "Subscription Status",
    maintenanceActualFaultType: "Actual Fault Type",
    maintenanceActualMethod: "Actual Handling Method",
    maintenanceApplyNo: "Repair Order No",
    maintenanceApplyNoLabel: "Repair Order No:",
    maintenanceAuditor: "Audited By",
    maintenanceAuditRemark: "Audit Remark",
    maintenanceAuditTime: "Audit Time",
    maintenanceConfirmTime: "Confirmation time",
    maintenanceCreateTime: "Created Time",
    maintenanceCreator: "Created By",
    maintenanceDeviceSnOrPurchaseNo: "Device SN / Purchase No",
    maintenanceDeviceSnOrPurchaseNoLabel: "Device SN / purchase order no.:",
    maintenancePaymentButtonPay: "Pay",
    maintenancePaymentPayAmount: "Pay {symbol}{amount}",
    maintenanceAddRepairDetailDialogTitle: "Add repair line items",
    maintenanceQuotationCustomDiscountTip: "Custom discount:",
    maintenanceQuotationDescriptionLabel: "Quotation description:",
    maintenanceEstimateFaultType: "Estimated Fault Type",
    /** RepairApply detail field (explicit keys for en-US) */
    maintenanceRepairApplyDetailLabel: "Detailed description:",
    maintenanceRepairApplyDetailPlaceholder: "Please enter a detailed description (max 400 characters)",
    maintenanceExpressNo: "Tracking no.",
    /** Flow record content.resultType: 1 payment 2 rejected 3 declined repair return */
    maintenanceFlowResultType1: "Payment",
    maintenanceFlowResultType2: "Rejected",
    maintenanceFlowResultType3: "Declined repair (return)",
    maintenanceFirmUser: "Repair Vendor",
    repairFirmUser_17017: "Zhongjiao Boer",
    repairFirmUser_17037: "Shanghai Mixue",
    repairFirmUser_122895: "Zhongjiao Boer (Repair)",
    repairFirmUser_123169: "Zhongjiao Boer (Shipping)",
    repairFirmUser_123533: "TCL (Shipping)",
    repairFirmUser_127795: "TCL (Repair)",
    repairFirmUser_128444: "Taobao C-store shipping",
    repairFirmUser_128112: "Shenzhen Service Center (Repair)",
    repairFirmUser_127796: "BOE (Repair)",
    maintenanceFirstDiagnosisMethod: "First Diagnosis Method",
    maintenancePdfPayTitle: "Scan to pay",
    maintenancePleaseEnterApplyNo: "Please enter repair order no",
    maintenancePleaseEnterNewSNCode: "Please enter new SN code",
    newSNCodelabel: "New SN code",
    maintenancePleaseEnterPurchaseNo: "Please enter purchase no",
    maintenancePleaseSelectActualFaultType: "Please select actual fault type",
    maintenancePleaseSelectEstimateFaultType: "Please select estimated fault type",
    maintenancePleaseSelectFirmUser: "Please select repair vendor",
    maintenancePleaseSelectProductType: "Please select product type",
    maintenancePleaseSelectQuotationPayType: "Please select quoted payment status",
    maintenanceProcessResult: "Repair Result",
    maintenanceProcessTime: "Repair Time",
    maintenanceProductModel: "Product model",
    maintenanceProductType: "Product Type",
    maintenancePurchaseNoLabel: "Purchase No:",
    maintenanceQuotationPayType: "Quoted Payment Status",
    maintenanceQuotationTime: "Quotation time",
    maintenanceQuotedPaid: "Quoted, Paid",
    maintenanceQuotedUnpaid: "Quoted, Unpaid",
    maintenanceReceiverPhone: "Receiver Phone",
    maintenanceRenewEffectiveTime: "Renew Effective Time",
    maintenanceSearchActualMethodLabel: "Actual Handling",
    maintenanceSearchFirstDiagnosisMethodLabel: "First Diagnosis",
    maintenanceSearchProposeMethodLabel: "Suggested Handling",
    maintenanceSuggestMethod: "Suggested Handling Method",
    maintenanceWarrantyValidTime: "Warranty Valid Time",
    male: "Male",
    math: "Math",
    math2: "Math",
    math281: "Math",
    maxBindLimit: "Max Bind Limit",
    min: "Actually No Pagination Needed",
    minhour: "When paginating",
    minmin: "Daily Student Score Improvement Analysis",
    minyear: "Grade Table Column Distinction",
    missingAccountInfo: "Missing required account info. Cannot proceed.",
    mobile: "Phone",
    mobileRequired: "Phone number is required",
    modify393: "Modify",
    modifyArea: "Modify Area",
    modifyAreaFailed: "Failed to modify area",
    modifyAreaSuccess: "Area modified successfully",
    modifySuccess: "Modified successfully",
    month: "Subscription Duration (Months)",
    month24: "months",
    monthAvgPrice: "Monthly Avg Price",
    monthlyRemainQuota: "Monthly remaining quota",
    monthsUnit: " months",
    monthUnit: " month",
    more: "More",
    name: "Name",
    nameEditOnce: "Name can only be edited once",
    nationwide: "Nationwide",
    needReplacementSendBack: "Need to replace and send back",
    newApplication: "New Application",
    newMachineAccount: "New Machine Account",
    newMachineAccountArea: "New Machine Account Area",
    newPasswordLabel: "Password:",
    newPasswordPlaceholder: "Enter 6-32 characters, numbers or letters only",
    newPhone: "New Phone",
    newPhoneLabel: "New Phone:",
    newStudentFacePhoto: "New Student Face Photo",
    newStudentFacePhoto43: "New Student Face Photo",
    newStudentFacePhotoLabel: "New Student Face Photo:",
    newStudentName: "New Student Name",
    newStudentName42: "New Student Name",
    newStudentNameLabel: "New Student Name:",
    nextCommunicateTime: "Next Communication Time",
    nextFollow: "Next Follow:",
    nextFollowPlaceholder: "Select next follow time",
    nextStep: "Next Step",
    nnycDuration: "Nnyc Duration",
    no: "No",
    noData: "No Data",
    none: "None",
    noNeedApply: "No Need to Apply in Current Status",
    normal: "Normal",
    not: "Not Activated",
    notHeld: "Not Held",
    notHeld282: "Not Held",
    notLearnable: "Not Learnable",
    notLearnable287: "Not Learnable",
    notRecommended: "Not Recommended",
    notRecommended285: "Not Recommended",
    notSubscribed: "Not Subscribed",
    notUse: "Not Use",
    num: "Face Count",
    objectiveQuestionCount: "Objective questions",
    oldPassword: "Old Password",
    oneStarCount: "1-Star",
    onlyLastHalfYearTip: "* Only data from the last 6 months is shown. For more learning data, please check the analyst system.",
    onlyLastYearTip: "* Only data from the last year is shown. For more learning data, please check the analyst system.",
    onlyUploadImage: "Only image files allowed!",
    openAutoRenewal: "Open Auto Renewal",
    openAutoRenewalConfirm: "Open Auto Renewal Service",
    openAutoRenewalTip: "Enable auto renewal? Service will auto-renew after expiry.",
    openFailed: "Activation failed",
    openService: "Open Service",
    openSuccess: "Activated successfully",
    openVideoCallService: "Open Video Call Service",
    operateChannel: "Operate Channel",
    operateDate: "Operate Date",
    operateTime: "Operate Time",
    operateType: "Operate Type",
    operation: "Operation",
    operation16: "Operation",
    operation32: "Operation",
    operation414: "Operation",
    operationFail: "Operation failed",
    operationSuccess: "Operation successful",
    operator: "Operator",
    systemAdministrator: "System Administrator",
    originalPhone: "Original Phone",
    originalPhoneLabel: "Original Phone:",
    originalPriceTotalLabel: "Original price total: ",
    originStudyTimeSec: "Origin study time (sec)",
    otherSubject: "Other",
    outOfWarrantyRepairRequiresFee: "Since out-of-warranty repair requires a fee, please go to",
    overallCorrectRate: "Overall correct rate",
    pass: "Temporary Pass",
    passHeld: "Pass Held",
    passHeld283: "Pass Held",
    passportRecordAdaptiveAccountText: "Adaptive Account",
    passportRecordExport: "Passport Record Export",
    passportReviewComplete: "Review Completed",
    passportReviewNoNeed: "No Review Needed",
    passportReviewPending: "Pending Review",
    passportStudyData: "Student Passport Study Data",
    passStatus: "Pass Status",
    passStatus263: "Pass Status",
    password: "Password:",
    pay: "Pay",
    payDeductTip: "This payment will deduct:",
    payFailTip: "Payment failed {symbol}{money}",
    paymentCompleted: "Payment completed",
    paymentFailed: "Payment failed",
    paymentSuccess: "Payment successful",
    paymentSuccessExclaim: "Payment successful!",
    paySuccessTip: "Successfully paid {symbol}{money}",
    pending: "Pending Review",
    pendingApprovalRetry: "Accounts pending approval. Please wait for approval and retry.",
    phoneColon: "Lead Phone Number:",
    phoneLabel: "Phone:",
    phoneNumber: "Phone Number",
    phoneNumber256: "Phone Number",
    phoneRebind: "Phone Rebind",
    phoneRebindTitle: "Phone Rebind",
    phoneVerifyCode: "Phone Verify Code:",
    physics: "Physics",
    pickupExchangeDesc: "After enabling the pickup store product exchange function, your students can place orders in the pickup store. After placing an order, you need to provide the corresponding physical product to the student and confirm the exchange in the agent mini-program order management. After confirming the exchange, the order's coins will be settled to you.",
    pickupStore: "Pickup Store",
    pickupStoreDisplaySetting: "Pickup Store Display Settings",
    pleaseAddProductQty: "Please add product quantity",
    pleaseEnter: "Please enter SN code",
    pleaseEnterAccountStatus: "Enter account status",
    pleaseEnterAdaptiveAccount: "Enter adaptive account",
    pleaseEnterAddress: "Enter delivery address",
    pleaseEnterAgentWarehouse: "Enter agent warehouse",
    pleaseEnterAnalystNamePhone: "Enter analyst name or phone",
    pleaseEnterAuditRemark: "Enter audit remark",
    pleaseEnterChangeType: "Enter change type",
    pleaseEnterCityDistrict: "Please enter city/district",
    pleaseEnterCrossEntityStudentNameAccount: "Enter student name or account",
    pleaseEnterDetailAddress: "Please enter detailed address, e.g. Province City District Street No.",
    pleaseEnterDetailDesc: "Enter detail description",
    pleaseEnterDeviceSN: "Enter device SN",
    pleaseEnterDeviceSNOrOrderNo: "Enter device SN or order no.",
    pleaseEnterEnglishName: "Enter student English name",
    pleaseEnterFirstDiagnosisResult: "Enter first diagnosis result",
    pleaseEnterInspectionDesc: "Enter inspection description",
    pleaseEnterMachineAccount: "Enter machine account",
    pleaseEnterMachineAccountPhone: "Enter machine account phone",
    pleaseEnterNameAccount: "Enter name or account",
    pleaseEnterNameOrAccount: "Enter name or account",
    pleaseEnterNewMachineSN: "Enter new machine SN",
    pleaseEnterNewPhone: "Please enter new phone number",
    pleaseEnterNewSNCode416: "Please enter new SN code",
    pleaseEnterPhone: "Enter phone number",
    pleaseEnterProvinceCity: "Select province/city",
    pleaseEnterPurchaseType: "Enter purchase type",
    pleaseEnterQualityRemark: "Enter quality check remark",
    pleaseEnterQuotationDesc: "Enter quotation description",
    quotationDescInputPlaceholder: "Enter quotation notes (max 400 characters)",
    pleaseEnterReceiver: "Enter receiver name",
    pleaseEnterReceiverAddress: "Enter receiver address",
    pleaseEnterReceiverPhone: "Enter receiver phone",
    pleaseEnterRechargeActivityDuration: "Enter recharge activity duration",
    pleaseEnterRemark: "Enter remark",
    pleaseEnterRepairResult: "Enter repair result",
    pleaseEnterReturnReceiver: "Enter return receiver name",
    pleaseEnterServiceCenterIdName: "Enter service center ID or name",
    pleaseEnterSNCode: "Enter SN code",
    pleaseEnterStudentAccount: "Enter student account",
    pleaseEnterStudentAccountOrName: "Enter student account or name",
    pleaseEnterStudentName: "Enter student name",
    pleaseEnterStudentNameOrAccount: "Enter student name or account",
    pleaseEnterStudentNamePhone: "Enter student name or phone",
    pleaseEnterStudentNamePhoneAccount: "Enter student name, phone or account",
    pleaseEnterTrackingNo: "Enter tracking number",
    pleaseEnterUser: "Enter user",
    pleaseEnterUserAccountOrName: "Enter user account or user name",
    pleaseEnterUserPlaceholder: "Enter user",
    pleaseEnterValidPhone: "Enter a valid phone number",
    pleaseEnterVerifyCode: "Enter verification code",
    pleaseEnterVideoCallStudentNameAccount: "Enter student name or account",
    pleaseFillApplicationReason: "Enter application reason",
    pleaseFillCardNo: "Enter subscription card number",
    pleaseFillCardPassword: "Enter subscription card password",
    pleaseFillGiftDuration: "Enter gift subscription duration",
    pleaseFillGiftReason: "Enter gift reason, 2-200 characters",
    pleaseFillMachineSN: "Enter machine SN code",
    pleaseFillMonth: "Enter month",
    pleaseFillNewPhone: "Enter new phone number",
    pleaseFillNewStudentName: "Enter new student name",
    pleaseFillOriginalPhone: "Enter original phone number",
    pleaseFillRemark: "Enter remark",
    pleaseFillStudentAccount: "Enter student account",
    pleaseGoToRepairManagement: "[Service Center] - [Repair Management] - [",
    pleaseMailDeviceToServiceCenter: "1. Please mail the device to the after-sales center. Details are as follows:",
    pleaseSearchCourseName: "Search course name",
    pleaseSearchStudyCount: "Search self-study count",
    pleaseSelect: "Please select operation type",
    pleaseSelectAccountStatus: "Select account status",
    pleaseSelectActualFaultType: "Select actual fault type",
    pleaseSelectActualMethod: "Select actual handling method",
    pleaseSelectAfterSalesMethod: "Select after-sales method",
    pleaseSelectAgent: "Please select agent",
    pleaseSelectAssignPerson: "Select assignee",
    pleaseSelectAtLeastOneOption: "Select at least one option",
    pleaseSelectAuditResult: "Select audit result",
    pleaseSelectCallStaff: "Select call staff",
    pleaseSelectChangeType: "Select change type",
    pleaseSelectCourseType: "Select course type",
    pleaseSelectCrossEntityApplyStatus: "Please select application status",
    pleaseSelectDateRange: "Please select date range",
    pleaseSelectDispatchType: "Select dispatch type",
    pleaseSelectExpectedTime: "Please select expected completion time",
    pleaseSelectExpressCompany: "Select express company",
    pleaseSelectFillResult: "Select fill result",
    pleaseSelectFirstDiagnosisMethod: "Select first diagnosis method",
    pleaseSelectFirstDiagnosisResult: "Select first diagnosis result",
    pleaseSelectFullTimeDateRange: "Select full-time start/end date",
    pleaseSelectFullTimeType: "Select full-time type",
    pleaseSelectGiftType: "Select gift subscription duration type",
    pleaseSelectGrade: "Select grade",
    pleaseSelectInspectionResult: "Select inspection result",
    pleaseSelectMonth: "Select month",
    pleaseSelectNonWarrantyReason: "Select non-warranty reason",
    pleaseSelectPassportType: "Please select passport type",
    pleaseSelectPaymentResult: "Select payment result",
    pleaseSelectProductFirst: "Please select product first",
    pleaseSelectProvinceCity: "Select province/city",
    pleaseSelectPurchaseType: "Please select purchase type first",
    pleaseSelectQualityResult: "Select quality check result",
    pleaseSelectRenewDurationType: "Please select renew duration type",
    pleaseSelectRenewMonth: "Select renew month",
    pleaseSelectRepairResult: "Select repair result",
    pleaseSelectRepairVendor: "Select repair vendor",
    pleaseSelectResult: "Select result",
    pleaseSelectReturnResult: "Select return result",
    pleaseSelectReviewStatus: "Please select review status",
    pleaseSelectServicePerson: "Please select service person",
    pleaseSelectShipAreaAgent: "Select shipment area agent",
    pleaseSelectStatus: "Select status",
    pleaseSelectSubject: "Select subject",
    pleaseSelectSuggestMethod: "Select suggested handling method",
    pleaseSelectSupervisorMark: "Select supervisor mark",
    pleaseSelectSupervisorShop: "Please select store",
    pleaseTimelyRepairProcess: "Please process repair in time",
    pleaseTimelyReturnProcess: "Please process return in time",
    pleaseUploadFullTimeAgreement: "Upload signed full-time agreement",
    pleaseUploadImage: "Please upload image",
    pleaseUploadImageOrVideo: "Please upload image/video",
    pleaseUploadReturnMedia: "Please upload return image/video",
    posterGeneratedDownload: "Poster generated, downloading",
    postLearningAccuracy: "Post-learning Accuracy",
    postStudyAvgAbility: "Post-study avg ability",
    precisionTestDuration: "Precision Test",
    preLearningAccuracy: "Pre-learning Accuracy",
    preTestCorrectRate: "Pre-test correct rate",
    prevStep: "Previous",
    priceLabel: "Price:",
    processImmediately: "Process Immediately",
    productImage: "Product Image",
    productName: "Product Name",
    profileCompleted: "Completed",
    profileNotCompleted: "Not Completed",
    proofMaterial: "Proof Material",
    proofMaterial44: "Proof Material",
    proofMaterialLabel: "Proof Material:",
    proofUploadTip: "Please upload proof that the child using the machine is from the same family. Supports jpg/png, max 20MB",
    proofUploadTipAtLeast2: "At least 2 images required",
    proofUploadTip9: "Please upload proof that the child using the machine is from the same family. Supports jpg/png, max 20MB",
    providePickupExchange: "Provide pickup store product exchange function",
    provinceCityLabel: "Province/City:",
    public: "Courier company",
    purchase: "Purchase Order No.:",
    qi: "Expiration Reason",
    qingtijiao: "Applicant",
    qita: "Other",
    qiyear: "Grade 7",
    qu: "Area",
    qualityInspection401: "Quality Inspection",
    qualityInspectionCompleted: "Quality inspection completed",
    queryFailRetry: "Query failed, please try again later",
    queryRenewMonthFailed: "Failed to query renew months",
    questionCount: "Question count",
    quotaNotExceeded: "Monthly Quota Not Exceeded",
    realNameAuth: "Real Name Auth",
    realNameAuth258: "Real Name Auth",
    rebindFailed: "Rebind failed",
    rebindSuccess: "Rebind successful",
    receiverLabel: "Receiver:",
    receiverPhoneLabel: "Receiver Phone:",
    recentModuleName: "Recent Self-study Module",
    recentSubscribeCancelDate30: "Recent Subscribe/Cancel Date",
    rechargeActivityDuration: "Recharge Activity Duration",
    rechargeActivityDurationReminder: "Recharge Activity Duration Reminder",
    rechargeAreaDuration: "Recharge Area Duration",
    rechargeAreaDurationTitle: "Recharge Area Duration",
    rechargeAtServiceCenter: "If the student is under your service center, please recharge in the account management page.",
    rechargeDurationTip: "Recharge duration can only be operated by student service center.",
    rechargeSuccess: "Recharge successful",
    rechargeUniversalDuration: "Recharge Universal Duration",
    recognitionCount: "Recognition Count",
    refreshFailed: "Refresh failed",
    region: "Region",
    reinspectionResult404: "Reinspection Result",
    rejectReason: "Reject Reason:",
    rejectReasonPlaceholder: "If rejected, enter reason (feedback to student). Max 50 chars",
    remainingPayment457: "Remaining Payment",
    remainingRechargeableDuration: "Remaining rechargeable duration",
    remark: "Remark:",
    remarkColumn: "Remark",
    removeConfirmDesc: "After removal, supervision and subscription services will no longer be available for this student.",
    removeConfirmSuffix: " from service center?",
    removeConfirmTip: "Confirm to remove student ",
    removeFromServiceCenter: "Remove from Service Center",
    renew: "Auto Renew",
    renewalReminder: "Machine Renewal Reminder",
    renewAreaTypeConfirm: "You selected region type. After renewal, it cannot be used directly due to common area mismatch. Confirm to renew?",
    renewDurationTypeLabel: "Renew Duration Type:",
    renewMonthLabel: "Renew Month:",
    renewPriceRuleNotExist: "Renew price rule not configured",
    renqu: "Current Authentication Area",
    repairFirstVisitAgreeLabel: "Agree",
    repairFirstVisitCaptureMediaLabel: "Capture Image/Video",
    repairFirstVisitDescLabel: "First Diagnosis Description",
    repairFirstVisitDescPlaceholder: "Please enter first diagnosis description, within 400 characters",
    repairFirstVisitExpectedTimeLabel: "Expected Completion Time",
    repairFirstVisitFactoryExpressInfoLabel: "Return Factory Express Info",
    repairFirstVisitLocalUploadLabel: "Local File Upload",
    repairFirstVisitMediaLabel: "First Diagnosis Images/Videos",
    repairFirstVisitMethodLabel: "First Diagnosis Treatment Method",
    repairFirstVisitPleaseSelectMethod: "Please select first diagnosis treatment method",
    repairFirstVisitPleaseSelectSuggestedMethod: "Please select suggested treatment method",
    repairFirstVisitReadFaultDescLabel: "Read Fault Description",
    repairFirstVisitRejectLabel: "Reject",
    repairFirstVisitResultLabel: "First Diagnosis Result",
    repairFirstVisitSaveLabel: "Save",
    repairFirstVisitSuggestedMethodLabel: "Suggested Treatment Method",
    repairFirstVisitUploadMediaLabel: "Upload Images/Videos",
    repairOrders: "repair order(s)",
    repairPayment: "Repair Payment",
    repairPayment399: "Repair Payment",
    repairQuotationActualFaultTypeLabel: "Actual Fault Type",
    repairQuotationActualMethodLabel: "Actual Processing Method",
    repairQuotationAddDetailLabel: "Add Repair Details",
    repairQuotationAmountLabel: "Repair Amount",
    repairQuotationCategoryLabel: "Repair Category",
    repairQuotationCustomDiscountLabel: "Custom Discount Amount",
    repairQuotationDeleteLabel: "Delete",
    repairQuotationDescPlaceholder: "Please enter quotation description, within 400 characters",
    repairQuotationDescriptionLabel: "Description",
    repairQuotationDescTitleLabel: "Quotation Description",
    repairQuotationDetailLabel: "Repair Details",
    repairQuotationFaultImagesLabel: "Fault images:",
    repairQuotationFillResultLabel: "Fill Result",
    repairQuotationNonWarrantyReasonLabel: "Non-warranty Reason",
    repairQuotationOperationLabel: "Operation",
    repairQuotationPleaseAddDetail: "Please add repair details",
    repairQuotationPleaseSelectActualMethod: "Please select actual processing method",
    repairQuotationPleaseSelectFaultClass: "Please select fault classification",
    repairQuotationSerialNoLabel: "No.",
    repairQuotationTotalAmountLabel: "Total Repair Amount",
    repairQuotationUploadImageLabel: "Upload Image",
    repairRejected: "Repair Rejected",
    repairRequest392: "Repair Request",
    reportDate: "Report Date",
    reportType: "Report Type",
    reportWeekStartDate: "Report Week Start",
    resend: "Resend",
    resendAfterSeconds: "Resend in {n}s",
    resendAfterSecondsTip: "Resend in {n}s",
    responsibleStudentCount: "Students Responsible",
    retakeCount: "Retake count",
    reTime: "Restart Time",
    returnExpress402: "Return Express",
    returnExpressNoLabel: "Return shipment",
    returnFactoryExpress: "Return Factory Express",
    returnFactoryExpress395: "Return Factory Express",
    returnFactoryFailed: "Return to factory operation failed",
    returnFactorySuccess: "Return to factory operation successful",
    review394: "Review",
    reviewStatus: "Review Status",
    reviewTime: "Review Time",
    san: "Grade 12",
    sanyear: "Grade 3",
    save: "Save",
    save11: "Save",
    saveFailed: "Save failed",
    saveSuccess: "Save successful",
    school: "School:",
    schoolOptionTip: "If your school is not in the list, please contact HQ support.",
    scmAccountMgmtAccountStatusFilterLabel: "Account status:",
    scmAccountMgmtAccountStatusFilterPlaceholder: "Enter account status",
    scmAccountMgmtActivateDateLabel: "Account activation date",
    scmAccountMgmtCertAreaPlaceholder: "Select province/city",
    scmAccountMgmtMachineAccountPlaceholder: "Enter machine account",
    scmAccountMgmtSnPlaceholder: "Enter SN code",
    scmAccountMgmtStudentSearchPlaceholder: "Enter student account or student name",
    scmAccountMgmtSubAuthFilterPlaceholder: "Select account status",
    scmSubAuthAlready: "Authorized",
    scmSubAuthIng: "Authorizing",
    scmSubAuthNot: "Unauthorized",
    search: "Search Student:",
    searchAnalyst: "Search Analyst",
    searchAnalystLabel: "Search Analyst:",
    searchStudent: "Search Student",
    searchStudentLabel: "Search Student:",
    searchUser: "Search user",
    sec: "Auto close after seconds",
    sectionName: "Section Name",
    selectDate: "Select date",
    selectDateTime: "Select date",
    selectedCount: "Selected {n}",
    selectSchoolLabel: "School:",
    selectStudentStep: "Select Students to Apply",
    selectStudentTip: "Select Student Notice",
    selfStudyDate: "Self-study Date",
    sendVerifyCode: "Send Code",
    serialNumber: "No.",
    serviceCenterId: "Service Center ID",
    serviceCenterId20: "Service Center ID",
    serviceCenterId39: "Service Center ID",
    serviceCenterIdLabel: "Service Center ID:",
    serviceCenterIdLower: "Service Center id",
    serviceCenterLabel: "Service Center",
    serviceCenterName: "Service Center Name",
    serviceCenterName21: "Service Center Name",
    serviceCenterName40: "Service Center Name",
    serviceCenterNameLabel: "Service Center Name:",
    serviceCenterSimple: "Service Center ID",
    serviceFollowUp: "Service Follow-up",
    servicePerson: "Service Person",
    servicePerson265: "Service Person",
    servicePerson305: "Service Person",
    servicePersonLabel: "Service Person:",
    servicePriceLabel: "Service Price:",
    shang: "Repair Vendor",
    sheng: "Biology",
    showSampleAccount: "Show sample account",
    shu: "Video Count",
    shuoming: "Detailed Description",
    shuxue: "Math",
    siyear: "Grade 4",
    slotTipStyleColorRedFontSize110: "images",
    snCode: "SN Code",
    snCodeLabel: "SN Code:",
    songuoSubscriptionCard: "Songuo Subscription Card",
    source: "Source:",
    sourceLabel: "Source:",
    selectSource: "Please select source",
    channelEnum12: "Knowledge Gap Assessment",
    channelEnum6301: "Referral",
    channelEnum6302: "Public Pool",
    channelEnum6303: "Ground Promotion",
    channelEnum6304: "New Media",
    channelEnum6305: "Others",
    channelEnum6306: "Outbound Call",
    channelEnum6307: "Walk-in Visit",
    channelEnum6308: "Marketing Campaign",
    channelEnum6309: "Case Library",
    channelEnum6310: "Business Card Sharing",
    stage: "Stage",
    stageGrade: "Stage/Grade:",
    stageGrade_6003001: "Elementary School",
    stageGrade_6003002: "Middle School",
    stageGrade_6003003: "High School",
    stageGrade_6003004: "Pre-K",
    stageGrade_6003005: "General",
    stageGrade_6004001: "Grade 1",
    stageGrade_6004002: "Grade 2",
    stageGrade_6004003: "Grade 3",
    stageGrade_6004004: "Grade 4",
    stageGrade_6004005: "Grade 5",
    stageGrade_6004006: "Grade 6",
    stageGrade_6004007: "Grade 7",
    stageGrade_6004008: "Grade 8",
    stageGrade_6004009: "Grade 9",
    stageGrade_6004010: "Grade 10",
    stageGrade_6004011: "Grade 11",
    stageGrade_6004012: "Grade 12",
    stageGrade_6004013: "Grade 13",
    stageGrade_6004020: "General",
    stageGrade_6004023: "K1",
    stageGrade_6004024: "K2",
    stageGrade_6004025: "K3",
    stageGrade261: "Stage/Grade",
    stageGrade294: "Stage/Grade",
    stageGrade303: "Stage/Grade",
    stageGradeEditOnce: "Stage/grade can only be edited once",
    stageGradeLabel: "Stage/Grade:",
    startTime: "Start Time",
    statisticsDate: "Statistics Date",
    statsDateRange: "Statistics Date Range",
    statsPeriod: "Statistics Period",
    status: "Status",
    student: "Student Account Subject",
    studentAccount: "Account",
    studentAccount18: "Student Account",
    studentAccount37: "Student Account",
    studentAccount45: "Student Account",
    studentAccountColon: "Student Account:",
    studentAccountLabel: "Student Account",
    studentEnglishName: "Student English Name",
    studentImproveAnalysisDataDescriptionTip: "Data updates daily at 9:00 AM. For definitions, please visit the Help Center.",
    studentImproveAnalysisExport: "Student Improve Analysis",
    studentImproveAnalysisImportantRemind: "Important reminder: To ensure fair comparison across grades, before calculating the last 180-day average score improvement, average exam score, and score standard deviation, we standardize each student's exam scores to a 100-point scale.",
    studentLabel: "Student",
    studentName: "Name",
    studentName19: "Student Name",
    studentName38: "Student Name",
    studentName40: "Student Name",
    studentName46: "Student Name",
    studentNameColon: "Student Name:",
    studentNameFormatTip: "Student name allows Chinese, English letters and separator \"·\" only.",
    studentNameFormLabel: "Student Name:",
    studentNameLabel: "Student Name",
    studentNameLabelColon: "Student Name:",
    studentNameOrAccount: "Student name/account",
    studentRiskLevel: 'Risk Level',
    studentRiskLevelNormal: 'Normal',
    studentRiskLevelLight: 'Light Risk',
    studentRiskLevelHeavy: 'High Risk',
    studentRiskLevelExempt: 'Exempt',
    pleaseSelectStudentRiskLevel: 'Please select risk level',
    lastUpdatedTime: 'Last Updated Time',
    studentNamePhone: "Student Name/Phone",
    studentNameStudyTimeReport: "Student name",
    studentServiceDurationTip: "Student service duration is {studentDays} days, does not meet {requiredDays} days requirement. Cannot renew for this student.",
    studentTransferApply: "Student Transfer Apply",
    studyCorrectRate: "Study correct rate",
    studyCount: "Self-study count",
    studyDate: "Study Date",
    studyDays: "Study days",
    studyDurationHours: "Study Duration (h)",
    studyTimeNoLimit: "No Limit",
    subject: "Subject",
    subject28: "Subject",
    subjectiveScoreRate: "Subjective score rate",
    subjectLabel: "Subject:",
    subjectName: "Subject",
    submit: "Submit",
    submitFailed: "Submit failed",
    submitInformation: "Submit Information",
    submitInformation3: "Submit Information",
    submitMaterial: "Submit Material",
    submitMaterial33: "Submit Material",
    submitSuccess: "Submit successful",
    submittedDeviceRepairApplication: "Your submitted device repair application",
    subscribe: "Subscribe",
    subscribe17: "Subscribe",
    subscribe7: "Subscribe",
    subscribeConfirm: "Subscribe Confirm",
    subscribeConfirm18: "Subscribe Confirm",
    subscribed: "Subscribed",
    subscribeStatusUnsubscribing: "Unsubscribing",
    subscribeStatusUnsubscribed: "Unsubscribed",
    subscribeStatusRenewFailed: "Renewal failed",
    subscribedSubjects: "Subscribed Subjects",
    subscribeDurationArea: "Subscribe Duration Area",
    subscribeDurationMonths: "Subscribe Duration Months",
    subscribeSubject: "Subscribe Subject",
    subscribeSubject268: "Subscribe Subject",
    subscribeSubjectManage: "Subscribe Subject Management",
    subscribeSubjectManage1: "Subscribe Subject Management",
    subscribeSubjectManage17: "Subscribe Subject Management",
    subscriptionCancelDate: "Recent Subscribe/Cancel Date",
    subscriptionCardLabel: "Subscription Card",
    subscriptionCardNo: "Subscription Card No.",
    subscriptionCardNoLabel: "Subscription Card No.:",
    subscriptionCardPassword: "Subscription Card Password",
    subscriptionCardPasswordLabel: "Subscription Card Password",
    subscriptionCardPasswordLabelColon: "Subscription Card Password:",
    subscriptionCardType: "Subscription Card Type",
    subscriptionCardTypeLabel: "Subscription Card Type:",
    subscriptionCardVerifySuccess: "Subscription card verified successfully",
    subscriptionDurationLessThan3: "Available subscription ≤3 days",
    subscriptionManagement: "Subscription Management",
    subscriptionSubjectLabel: "Subscription Subject:",
    supervisorAccount: "Supervisor Account",
    supervisorExpired: "Supervision Expired",
    supervisorMark: "Supervisor Mark",
    supervisorNoSupervise: "No Supervision",
    supervisorNumOverTwo: "Supervisors with 2+ Score Submissions (Last 180 Days)",
    supervisorOnlineOnly: "Online Only",
    supervisorShop: "Store",
    supervisorStatus: "Supervisor Status",
    supervisorStudyRoom: "Study Room",
    supervisorUnmarked: "Unmarked",
    supervisorValidDate: "Supervisor Valid Date",
    syncCourse: "Sync Course Accuracy Rate",
    syncCourseCorrectQuestionCount: "Sync course correct answers",
    syncCourseCorrectRate: "Sync course correct rate",
    syncCourseDuration: "Sync Course",
    syncCourseEffectiveDuration: "Sync Course Effective",
    syncCourseStatus: "Sync Course Status",
    syncCourseStatus264: "Sync Course Status",
    syncCourseStudyDuration: "Sync Course Study",
    syncCourseTotalQuestionCount: "Sync course questions",
    syncErrorCorrectionDuration: "Sync Error Correction",
    tabFollowRecord: "Follow Record",
    tabFullTimeDeclare: "Full-time Declaration",
    tabGoldDetail: "Gold Detail",
    tabMachineSubscribe: "Machine Subscribe",
    tabServiceRelation: "Service Relation",
    tabSuperviseService: "Supervise Service",
    tabUserRecord: "User Record",
    tabVideoCall: "Video Call",
    taskCardCompleteTime: "Task Card Completion Time",
    taskCardName: "Task Card Name",
    teacherImproveAnalystLabel: "Analyst",
    teacherImproveDdjBandHigh: "Above 120 hours",
    teacherImproveDdjBandLow: "Below 60 hours",
    teacherImproveDdjBandMid: "60–120 hours",
    teacherImproveDdjValidHoursFull: "DDJ valid study hours (last 180 days, unit: hours)",
    teacherImproveEnterDuration: "Enter duration",
    teacherImprovePleaseEnterAnalyst: "Enter analyst",
    teacherImprovePleaseSelectStatDay: "Please select statistics day",
    teacherImprovePleaseSelectStatYear: "Please select statistics year",
    teacherImproveStatDay: "Statistics day",
    teacherImproveStatYear: "Statistics year",
    teacherStatusAllocated: "Assigned",
    teacherStatusNoLimit: "No Limit",
    teacherStatusPendingAllocate: "Pending Assign",
    tempPassHeld: "Temp Pass Held",
    tempPassHeld284: "Temp Pass Held",
    tempPassType: "Temporary Pass Type",
    text0128: "Please fill in your express delivery information on the page",
    text02ok: "Fault description button disabled",
    text041r: "Avoid damage during transit",
    text08wg: "Return shipping instructions:",
    text0dkm: "If accessories are missing",
    text0kxb: "Unit",
    text0nkv: "Not as final product judgment result",
    text0pnd: "Then",
    text0tih: "Your submitted",
    text0twu: "Payment information",
    text0uhw: "Use WeChat Pay",
    text0y39: "Dear partner:",
    text0z0g: "Actual fault type",
    text13p1: "Review Description:",
    text16i0: "I have read and understood",
    text1a2b: "Table merge field",
    text1b76: "Quality inspection",
    text1cd3: "Tracking number",
    text1e1u: "Payment completed",
    text1fdw: "Supervisor",
    text1gih: "Initial diagnosis reminder",
    text1nox: "Score stability (days)",
    text1nv3: "Quality inspection",
    text214l: "Total repair amount",
    text2192: "Image preview",
    text23it: "Whole machine replacement",
    text23os: "Then",
    text26cj: "Exceeded",
    text29kt: "Page size",
    text2af3: "Vertical",
    text2cem: "Pass code",
    text2eo7: "Old data",
    text2fmi: "Total repair amount:",
    text2iu8: "In-warranty repair",
    text2lb9: "Current page",
    text2obh: "Default selection",
    text2py7: "Initial diagnosis description",
    text2rn0: "Out-of-warranty reason:",
    text2us2: "Courier company",
    text2v3y: "Actual fault type:",
    text2vll: "Out-of-warranty repair requires fee",
    text2vpv: "Vendor address",
    text303b: "Please select subject",
    text358v: "Set default parameters",
    text3alh: "Region",
    text3bv7: "Get",
    text3d7q: "All status table columns",
    text3dfv: "Contact:",
    text3ehe: "Suggested handling method",
    text3gqv: "Return images",
    text3x2u: "Customer phone:",
    text3yj8: "View repair quote details on the page, and",
    text3zas: "Repair detail data",
    text3zgs: "Size",
    text41ik: "Customer name:",
    text428g: "Repair Vendor:",
    text458z: "English",
    text46ll: "Video",
    text498v: "Your device repair application",
    text49ly: "Payment description",
    text4dse: "Close fault description popup",
    text4dwa: "Please after mailing",
    text4g8p: "Your device repair application",
    text4h32: "Reinspection remark",
    text4hjl: "Re-inspection result:",
    text4kta: "Popup will appear in",
    text4q11: "Repair amount",
    text4sjg: "Current element exceeds current page",
    text4u2y: "Or changed search criteria",
    text4w53: "Fill in quote",
    text4xfy: "Form add",
    text4y7a: "OrderStatus",
    text583c: "Device diagnosed by vendor",
    text58ht: "Suggested Handling:",
    text5cxk: "Information as follows",
    text5jeq: "Out-of-warranty repair requires fee",
    text5k7h: "Dispute result:",
    text5kpp: "Chemistry",
    text5lbq: "Geography",
    text5mne: "Biology",
    text5ogt: "Return shipping",
    text5pai: "Initial diagnosis image",
    text5s9o: "Otherwise should be default",
    text5sdf: "Submit in days",
    text5stz: "Transfer records",
    text5tkq: "Table data query",
    text5x7e: "Need to send entire machine",
    text60d9: "Your submitted",
    text615b: "Support credit card payment",
    text638k: "Re-inspection notes:",
    text63rq: "Table data",
    text646e: "Repair management",
    text69ag: "Return shipping",
    text6cgu: "Dispute description",
    text6kvt: "Fault description popup",
    text6of5: "Repair details:",
    text6psd: "Contact address:",
    text6qhb: "Machine",
    text6rmc: "Dynamic cutting",
    text6sgg: "Out-of-warranty repair requires fee",
    text6vg3: "Return page number",
    text6vs3: "Vendor return/exchange",
    text6xfh: "Quality inspection completed",
    text744d: "Device needs out-of-warranty repair after vendor diagnosis",
    text7457: "Subject",
    text759t: "Out-of-warranty repair",
    text75jj: "Number to uppercase",
    text75l0: "Return original machine unrepaired",
    text7gjz: "Video call records",
    text7gkh: "Return information",
    text7m03: "Fault description",
    text7urb: "And repair payment popup",
    text7wcs: "If sent with other courier COD",
    text7z8o: "Frontend hardcoded first",
    text82m7: "So this must be set to",
    text82n2: "Get reason not covered by warranty",
    text84k1: "Repair payment",
    text84xf: "All set to default",
    text8av1: "Or changed search criteria",
    text8cva: "Please select person",
    text8me7: "Please pack machines or accessories for return properly",
    text8mih: "Quotation result:",
    text8pgz: "No pass in hold",
    text8qc9: "Required field initialization",
    text8ri1: "Pending submit",
    text8sol: "View repair quote details on page",
    text8uqq: "Courier company name",
    text8xie: "Long term",
    text8xvz: "Reinspection result",
    text8zqy: "Repair management",
    text8zt7: "Switch follow-up option",
    text97nv: "Only applicable",
    text98yq: "Media is image",
    text9aw1: "Need to replace and send back",
    text9hs6: "Test",
    text9i1t: "Non-warranty reason",
    text9j44: "Vendor return/exchange",
    text9jj5: "Or manually clear and click search",
    text9lhk: "Chemistry",
    text9lns: "Service center",
    text9m6j: "Collapse",
    text9shl: "Out-of-warranty repair requires fee",
    text9tad: "After-sales address",
    text9uwa: "Biology",
    texta2iq: "Or manually clear and click search",
    texta79g: "实际故障类型：",
    texta8dx: "Application",
    textabwu: "Return courier information:",
    textad7l: "Non-warranty product repair quote",
    textaiqt: "Cancel repair pending return",
    textajcd: "Customer submitted",
    textako6: "Set request parameters",
    textango: "Courier requirement",
    textapja: "Foundation building effect",
    textaspy: "Test description",
    textauck: "Discount amount:",
    textavdq: "Sync course accuracy rate",
    textb067: "Quote description",
    textb2tm: "Reason",
    textb31s: "Paid and repairing",
    textb635: "Dear partner",
    textbbne: "No tracking info yet",
    textbcwr: "Repair amount",
    textblwy: "Repair result",
    textbmh3: "Thank you for your cooperation",
    textbxrg: "Review",
    textc6fo: "Current",
    textc8ye: "Cost will be at your expense",
    textcczt: "Get",
    textckrt: "Quote description",
    textclba: "Repair vendor",
    textclfy: "Factory return courier information:",
    textcoch: "Student application",
    textcos4: "Non-warranty reason",
    textcovx: "Confirmer signature:",
    textcpyy: "Self-pay for damage",
    textcu1q: "Please select subject",
    textcwbf: "Short term",
    textcx7z: "Initial diagnosis result",
    textcz90: "Modify",
    textd124: "All accessories and packaging",
    textd4ip: "Repair payment",
    textd8ty: "Get fault type",
    textdiws: "Test description",
    textdjs3: "Collection",
    textdkbb: "Expired",
    textdsln: "Dispute result",
    textdt32: "Repair management",
    textduw5: "No more popup",
    textdv5x: "Repair management",
    textdxc4: "Repair application and return reminder",
    texte0hp: "View image",
    texte27e: "Click clear button",
    texte2as: "Thank you for your cooperation",
    texte4o5: "Returned Logistics Info",
    texte6z6: "Repair result:",
    textee6v: "Dispute",
    texteeeh: "COD not accepted except SF Express",
    textefhh: "Math",
    texteg6t: "Notes:",
    texteifo: "Table List Display Fields",
    textekrr: "Quality inspection notes:",
    texteusc: "Export Parameters",
    texteveb: "Unsubscribe",
    textew1u: "Then",
    textew8e: "Return Shipping Info",
    textf2fv: "Initial diagnosis handling:",
    textf2wp: "Choose Whether to Pay",
    textf35y: "Device Repair Applications",
    textf6jv: "Return shipping result:",
    textf6yk: "Pending Verification",
    textf954: "Repair Result",
    textf9ay: "Historical Search Parameters",
    textfb1f: "Grant",
    textfe65: "After-sales Repair Reminder",
    textfea8: "Calculate total height of files to print based on ratio",
    textfgwm: "Quality Check Passed, Waiting for Return",
    textfhfk: "English",
    textfl9n: "Save and pay",
    textfotn: "Device requires out-of-warranty repair after manufacturer diagnosis",
    textfrqk: "Class Name",
    textfvoj: "Not Reviewed",
    textfwit: "Total Paper Height",
    textfy7i: "Science",
    textfz2w: "Fault Images",
    textg052: "New Device",
    textg4ij: "Initial diagnosis description:",
    textg6c0: "Please",
    textg735: "Repair Category",
    textg9iq: "Device Diagnosed by Manufacturer",
    textgbp2: "After-sales Repair Reminder",
    textgbzr: "Due to",
    textge5g: "Confirmer Signature",
    textgkhx: "Return to Factory Shipping",
    textgosk: "Passed",
    textgr7g: "Unsubscribe",
    textgrxx: "Proof Not Passed",
    textgtjd: "WeChat Payment Recommended",
    textgwdb: "Detection",
    textgyac: "Horizontal",
    textgzgy: "Fault Image",
    texth07c: "Quotation Result",
    texth1uz: "Device Repair Request(s)",
    texth5tk: "Thank You for Your Cooperation",
    texth8j6: "Otherwise Original Device Will Be Considered Not Repaired",
    texthayb: "No Data No Popup",
    texthed3: "Preliminary Judgment Based on Product Appearance",
    texthf21: "Actual handling method:",
    texthfjq: "Unit",
    texthgap: "Product Type",
    texthqio: "Return Instructions",
    texthr60: "Unsubscribe",
    texthsad: "Daily Score Standard Deviation",
    texthsjt: "Chinese",
    texthsuv: "OperationType",
    texthxic: "Number of Answers",
    texti0by: "Current Page of Traversed Element",
    texti4n0: "Unsubscribe",
    texti7uy: "Due to",
    texticu2: "Click Clear Button",
    textig4p: "Fetch Data",
    textijzk: "Common Dialog",
    textikaf: "Rate Now",
    textikvr: "Repair Details",
    textir0j: "Used for Initializing Required Fields",
    textislp: "Unsubscribe",
    textitx4: "Thank You",
    textixqc: "Already Approved",
    textjaby: "Face Reference Photo",
    textjd4h: "Not Exceeded",
    textjeoq: "Dear Partner",
    textjsfe: "Exported",
    textjxax: "Need to Resend",
    textk7qh: "Review",
    textk916: "Image",
    textk9y5: "Dear Headquarters Staff",
    textkfxg: "Manual Follow-up",
    textkgfd: "All",
    textki4i: "Process Records",
    textkir1: "Contact phone:",
    textkkko: "Whether Crossed",
    textkltr: "Initial Diagnosis Reminder:",
    textkot6: "Create",
    textkpx4: "Return Express Information",
    textkqio: "Set All as Default",
    textkscu: "Check Logistics Status",
    textkwff: "Repair Payment",
    textl5vr: "Original PriceTotal Amount",
    textla63: "维修金额合计：",
    textlfnm: "Your Device Repair Request",
    textlglu: "Repair Payment",
    textli61: "Notes",
    textll3j: "Correct Answers in Sync Class",
    textlou3: "New Data",
    textlrf8: "Personnel",
    textlw09: "Science",
    textlw5h: "Unit",
    textlw91: "Pending Review",
    textlzqa: "Quality Inspection Notes",
    textm0p2: "Table Data Query",
    textm3wt: "Distribution Reason",
    textm4v8: "Video",
    textm6u6: "Callback Function",
    textmem9: "Corresponding Express Fee Needs to Be Borne by You",
    textmgy6: "Replacement Pending Return",
    textmije: "Repair Rejected",
    textmiye: "Subject",
    textmku1: "维修明细：",
    textmmg0: "Click Clear Button",
    textmnjq: "Or Changed Search Criteria",
    textmp23: "Fault images:",
    textmq6j: "Collapse",
    textmqah: "Actual Processing Method",
    textmqmr: "After-sales Address",
    textmt4o: "Source Type",
    textmtn7: "Return Express",
    textmtsi: "Subject",
    textmwny: "Repair Request",
    textn1kz: "Quotation",
    textn6rk: "As",
    textn8jo: "Return Information",
    textnd2i: "Otherwise Should Be Default",
    textnlkg: "Repair Details",
    textno8d: "Table Fields",
    textnp6g: "Customer Phone",
    textnqvz: "Quality Inspection Image",
    textnsn7: "Recipient information:",
    textnuvo: "Contact method",
    textnv37: "Initial diagnosis result:",
    textnwkk: "Get Search Parameters From",
    textnxhz: "View Repair Quotation Details on Page",
    textny49: "If Search Criteria is Empty",
    texto0ao: "Inspection result:",
    texto2a1: "Control Follow-up Record Popup",
    texto2nu: "Actual Fault Type",
    texto7f9: "非保修原因：",
    texto91d: "All Status Table Columns",
    textocqw: "Then Use Historical Search Criteria",
    textocuo: "If You Have Objections",
    textod5b: "Table Total Count",
    textoetj: "Review Result:",
    textoh1d: "Overdue Pickup Will Be Handled Separately",
    texton15: "Re-inspection",
    textoq1w: "Calculate If It Exceeds Location",
    textoxa7: "Student Name",
    textoxlo: "Your Submitted",
    textoy9p: "Original price total:",
    textp08s: "Our Repair Center Provides Free Storage for You",
    textp434: "After Mailing Please",
    textp5mv: "Service Center",
    textp6kc: "Build Request Parameters",
    textp709: "Return Result",
    textp9nw: "Days to Build Foundation and Overcome Knowledge Gaps",
    textpc7n: "Number to Words",
    textpcmy: "Math",
    textphoc: "Repair Order(s)",
    textphxg: "Completed",
    textpllk: "After-sales Staff Will Expedite Processing for You",
    textpo0j: "Under Repair",
    textpoh2: "Inspection Image",
    textppwi: "Geography",
    textpq7v: "Factory Return Express Information",
    textpsj3: "Clicked Export",
    textpth9: "Table Title",
    textpycm: "Otherwise Should Be Default",
    textpyte: "Otherwise Should Be Default",
    textpzwi: "Fault Book Name Read Status",
    textq7tb: "Contact Address",
    textq803: "Latest",
    textqda5: "Contact",
    textqefr: "Requires Out-of-warranty Repair",
    textqgtm: "Calculate Current",
    textqj07: "Manufacturer Return/Exchange",
    textqm88: "Quality Inspection Status",
    textqvas: "Dispute description:",
    textqyyc: "Review Status",
    textqz8y: "Recipient Information",
    textqzt0: "Repair description:",
    textr00k: "Repair Amount Original Price",
    textr1cq: "Will Refund Original Repair Payment",
    textr1hc: "Expand",
    textr1ni: "Under Repair",
    textr8sg: "Process Immediately",
    textrab9: "Get Items to Print",
    textrbae: "故障图片：",
    textrbki: "Report",
    textreh6: "If Empty",
    textrg6y: "Your Device Repair Request",
    textrj1v: "Actual Processing Method",
    textrjax: "Requires Out-of-warranty Repair",
    textrnzc: "Custom Dialog Reminder",
    textropu: "Quotation description:",
    textrv31: "In Possession",
    textrvkf: "Initial Diagnosis Processing Method",
    texts2sr: "Or Click Search After Manually Clearing",
    texts5d7: "Fetch Data",
    texts6oz: "And Choose Whether to Pay",
    texts82f: "Fault Type",
    texts9rp: "Student Recent",
    textsamb: "Pass",
    textseap: "Inspection description:",
    textselj: "Final Judgment Subject to Actual Inspection Results by Repair Personnel",
    textsfmz: "Table List Display Fields",
    textsh0l: "After-sales Repair Reminder",
    textsh84: "Initial Diagnosis",
    textsqsh: "Display Red",
    textsrm2: "Service Center",
    textstfk: "Total Answers in Sync Class",
    textsuj7: "Disagree with Repair",
    textsxey: "Review Remarks",
    textt0rw: "Judgment Condition",
    textt1am: "Please in",
    textt2ff: "Choose Whether to Pay",
    textt4uf: "Or Click Search After Manually Clearing",
    textt611: "Return Express",
    textt813: "Dear partner:",
    textt9n0: "Pending Entry",
    texttaxz: "Get Repair Details",
    textth1j: "Image Type and Quality",
    texttllb: "Repair Evaluation",
    texttrgt: "Popup Will",
    texttu61: "Table Merge Fields",
    texttzem: "Quality inspection status:",
    textu5s2: "尊敬的合作伙伴：",
    textucfs: "Payment result:",
    textucpq: "If You Have Objections",
    textuczq: "Unsubscribe",
    textuir4: "Proof Not Passed",
    textunic: "If Due to Non-compliant Packaging",
    textutm4: "Return Express",
    textuw1i: "Already Shown",
    textv07h: "Change",
    textv3y4: "Already Approved",
    textv4jl: "Set All as Default",
    textvbaq: "Then",
    textvd87: "Processing Method for Parents",
    textvdb7: "Lower Than",
    textvdzu: "Total Count",
    textves7: "Initial Diagnosis",
    textvfii: "Search Form",
    textvflo: "Math",
    textvg1v: "Table Data Query",
    textvgmx: "Full Device Replacement",
    textvms0: "Repair Category",
    textvo61: "Day(s) Submitted",
    textvocn: "Is Part",
    textvrvj: "Initial Diagnosis Notes",
    textvs5i: "If There Is",
    textvwq8: "Aspect Ratio",
    textvx0u: "After-sales Staff Will Expedite Processing for You",
    textvyzx: "Fill in Your Express Information on the Page",
    textw07v: "Chinese",
    textw3lc: "Select Basic Insurance",
    textw58a: "Unsubscribe",
    textw84m: "After-sales Staff Will Expedite Processing for You",
    textw8lj: "Factory Return Express",
    textwa43: "Please in",
    textwaad: "Repair Progress",
    textwdoz: "Manufacturer address:",
    textwf3j: "Inspection",
    textwhs5: "Search Criteria Column",
    textwih6: "Inspection Result",
    textwj2j: "Re-inspection Result",
    textwjxd: "Information As Follows",
    textwo1j: "Repair Quotation",
    textwrja: "Default",
    textwzxq: "Agree to Repair",
    textx02y: "Purchase amount:",
    textx3h1: "报价说明：",
    textx3li: "SF Express Collect for Devices Within Normal Warranty",
    textx66h: "Click Clear Button",
    textx6cv: "Top Text Prompt",
    textx89t: "Total Count",
    textxa7k: "Set All as Default",
    textxaqy: "Repair Management",
    textxeb0: "Contact Phone",
    textxefe: "Device Repair Request(s)",
    textxmip: "Student Basic Information",
    textxngk: "But Assume No Other Responsibilities",
    textxo9n: "Flow Record:",
    textxqpu: "Loading Failed",
    textxqvc: "If Expired Please Contact Dealer or Customer Service to Re-download File",
    textxwh2: "Popup Will",
    texty0vr: "Page Size",
    texty3cr: "No Expired Passes",
    texty880: "Margin",
    texty8st: "Repair Instructions",
    textycff: "Physics",
    textyfdy: "Search Criteria Column",
    textyo22: "Total Repair Amount",
    textyt4i: "Physics",
    textywfr: "Based on",
    textywx2: "Payment Result",
    textz14c: "System Follow-up",
    textz2l6: "Dou Zhaobin",
    textz2yr: "Suggested Processing Method",
    textz8e2: "Verification Info in Request Header, etc.",
    textzc0w: "Total Count",
    textzc96: "Or Changed Search Criteria",
    textzcvk: "Payment description:",
    textzefb: "Enable Fault Description",
    textzfvb: "Expand",
    textzk14: "Contact",
    textzk3n: "Dispute Result",
    textzunm: "And Choose Whether to Pay",
    textzzes: "Track",
    thankYouForYourCooperation: "Thank you for your cooperation. Our after-sales staff will process it as quickly as possible!",
    thisDeductDuration22: "This Deduct Duration",
    thisReturnDuration23: "This Return Duration",
    thisSubscribeSubject20: "This Subscribe Subject",
    thisUnsubscribeSubject21: "This Unsubscribe Subject",
    threeStarCount: "3-Star",
    time: "Operation Time",
    tipDuplicateApply: "The following students have already applied or are in payment. Please change your selection.",
    to: "to",
    topicEndTime: "Topic End Time",
    topicName: "Topic Name",
    topicStartTime: "Topic Start Time",
    totalDuration: "Total",
    totalDurationHours: "Total Duration (hours)",
    totalQuestionCount: "Total questions",
    totalQuestionTime: "Total answering time",
    twoStarCount: "2-Star",
    type: "Operation Type",
    unbind2: "Unbind",
    unbindConfirmTip: "Confirm to unbind {account} from learning machine? After unbinding, this account cannot use the machine for learning, and subscribed subjects will be invalid immediately.",
    unbindFailed: "Unbind failed",
    unbindRelation: "Unbind Relation",
    unbindSuccess: "Unbind successful",
    underRepair400: "Under Repair",
    unfreeze: "Unfreeze",
    unfreezeSuccess: "Account unfrozen successfully",
    universalAvailableDurationLabel: "Universal Available Duration:",
    universalBalance: "Universal Subscription Balance",
    universalBalanceLabel: "Universal Duration Balance:",
    universalDurationBalance: "Universal Duration Balance",
    universalDurationRecharge: "Universal Duration Recharge",
    unstudyDays: "Unstudy days",
    unsubscribe: "Unsubscribe",
    unsubscribe16: "Unsubscribe",
    unsubscribe6: "Unsubscribe",
    unsubscribeConfirm19: "Cancel Subscribe",
    unsubscribeEffective: "Unsubscribe Effective",
    unsubscribeEffective5: "Unsubscribe Effective",
    unsubscribeEffective8: "Unsubscribe Effective",
    unsubscribeFailed: "Unsubscribe failed",
    unsubscribeSuccess: "Unsubscribed successfully",
    uploadCountLimit9: "Image/video count must not exceed 9!",
    uploadFail: "Upload failed",
    uploadFailRetry: "Upload failed, please retry",
    uploadLimit10Images: "Upload limit reached, max 10 images",
    uploadLimit9Images: "Upload limit reached, max 9 images",
    uploadLimitError: "Upload limit reached. Max 9 images.",
    uploadLimitReached: "Upload limit reached",
    uploadMediaMax9Count: "Maximum 9 images/videos allowed!",
    uploadMediaSizeExceed20M: "Image/video size cannot exceed 20MB!",
    uploadSizeLimit20MB: "Image/video size must not exceed 20MB!",
    uploadTip: "JPG/PNG only, max 500KB",
    use: "Use",
    useLandlineOutbound: "Use landline outbound",
    useMobileOutbound: "Use mobile outbound",
    user: "User Account",
    userAccount: "User Account",
    userActivityFlag: "User activity",
    userLabel: "User",
    userName: "User Name",
    userNameLabel: "User Name:",
    userPlaceholder: "User name/contact",
    userProfile: "User Profile",
    validateFailedRetry: "Validation failed. Please retry.",
    verifyCode: "Verify Code",
    verifyCodeLabel: "Verify Code:",
    verifyCodeRequired: "Verification code is required",
    verifyCodeSendSuccess: "Verification code sent successfully",
    verifyFailed: "Verification failed",
    verifyFailedBind: "Verification failed. Cannot bind student account.",
    videoCallDialingTimeLabel: "Dialing Time",
    videoCallDurationColon: "Call Duration:",
    videoCallFollowPeopleLabel: "Personnel",
    videoCallFollowPeoplePlaceholder: "Please select personnel",
    videoCallRecord: "Video Call Record",
    videoCashAccountLabel: "Cash Account",
    videoCount: "Videos",
    videoDuration: "Video Duration",
    videoPaymentMethodLabel: "Payment Method",
    videoServiceDurationColon: "Service Duration:",
    videoWatchTimeApprox: "Video watch time (approx.)",
    week: "Week",
    withdrawApplication4: "Withdraw Application",
    withdrawApplySuccess: "Withdraw application successful",
    within100Chars: "Within 100 characters",
    within500Chars: "Within 500 characters",
    wu: "No Review Needed",
    wuyear: "Grade 5",
    xinma: "New SN Code",
    xue: "Chemistry",
    xuema: "Learning SN Code",
    xueque: "Post-learning Accuracy",
    xuexiao: "School",
    year: "Year",
    yes: "Yes",
    yesRecognitionStatus: "Recognition Status",
    yi: "Repair Info",
    yici: "Recent Exam Score (Days)",
    yiciday: "Recent Exam Date",
    yimonthhour: "Default One Month",
    yiyear: "Grade 1",
    yongdi: "Common Location",
    you: "Fill in your shipping and return information on the page.",
    youbackyou: "Thank you. Our after-sales team will process your request as soon as possible.",
    youci: "Are you satisfied with this repair service?",
    youshi: "Valid Duration",
    yuan: "$",
    zeroStarCount: "Zero-star Subject Count",
    fullTimeUploadLimit: "Up to 10 images, max 8MB each, JPG/PNG supported",
    fullTimeUploadKeyPage: "Key pages of the agreement must be uploaded",
    fullTimeKeyPageStudentInfo: "1. Student basic information",
    fullTimeKeyPageStudyPeriod: "2. Full-time study start and end dates; mismatches with the form will be rejected",
    fullTimeKeyPageChargeInfo: "3. Fee details",
    zongshi: "Total Answer Time",
    /* ── Class Management ── */
    cmClassName: "Class Name",
    cmStageGrade: "Stage / Grade",
    cmHeadTeacher: "Head Teacher",
    cmAnalyst: "Analyst",
    cmStudentCount: "Student Count",
    cmClassStatus: "Class Status",
    cmScheduledHours: "Attended/Scheduled Hours",
    cmScheduledLessons: "Attended/Scheduled Classes",
    cmSmartCourse: "Smart Course",
    cmCampus: "Campus",
    cmPleaseEnterClassName: "Please enter class name",
    cmPleaseSelectHeadTeacher: "Please select head teacher",
    cmPleaseSelectAnalyst: "Please select analyst",
    cmPleaseSelectStageGrade: "Please select stage / grade",
    cmPleaseSelectSubject: "Please select subject",
    cmStatusNotStarted: "Not Started",
    cmStatusInProgress: "In Progress",
    cmStatusCompleted: "Completed",
    cmStatusClosed: "Closed",
    cmEditClass: "Edit Class",
    cmAddClass: "+ Add Class",
    cmSchedule: "Schedule",
    cmRollCall: "Roll Call",
    cmAddStudent: "Add Student",
    cmStudentKeyword: "Student Name / Account",
    cmPleaseEnterStudentKeyword: "Please enter student name or account",
    cmClassType: "Class Type",
    cmClassWay: "Class Size",
    cmClassCapacity: "Class Capacity",
    cmClassHour: "Supervisor Lessons",
    cmClassHourRange: "Supervisor lessons range is 1-9999",
    cmClassContent: "Class Content",
    cmInstructor: "Instructor",
    cmRemark: "Remark",
    cmUnitPerson: "Person",
    cmPleaseSelectClassType: "Please select class type",
    cmPleaseSelectClassWay: "Please select class size",
    cmPleaseSelectStage: "Please select stage",
    cmPleaseSelectGrade: "Please select grade",
    cmPleaseSelectInstructor: "Please select instructor",
    cmPleaseEnterCapacity: "Please enter quantity",
    cmClassCapacityRange: "Class capacity must be between 1 and 9999",
    cmPleaseEnterClassHour: "Please enter supervisor lessons",
    cmPleaseEnterClassContent: "Please enter class content",
    cmPleaseEnterRemark: "Please enter remark",
    cmClassNameExample: "E.g.: 26Summer Middle Math Analyst Wang - Fri 9AM - Class 01",
    cmMore: "More",
    cmOpenClass: "Open Class",
    cmCloseClass: "Close Class",
    cmViewDetail: "View Details",
    cmConfirmDeleteClass: "Are you sure to delete this class?",
    cmSearchClass: "Search Class",
    cmPleaseSearchClassName: "Please search class name",
    cmCourseTitle: "Course Name",
    cmPleaseEnterCourseTitle: "Please search course name",
    cmPleaseSelectClassStatus: "Please select class status",
    cmPleaseSelectCampus: "Please select campus",
    /* ── Class Schedule (Course Information) ── */
    csCourseType: "Course Type",
    csAnalyst: "Analyst",
    csLessonStatus: "Lesson Status",
    csClassTime: "Class Time",
    csStartDate: "Start Date",
    csEndDate: "End Date",
    csClearFilter: "Clear Filter",
    csRegularSchedule: "Regular Schedule",
    csSpecialSchedule: "Special Schedule",
    csBatchEdit: "Batch Edit",
    csEditClassTime: "Edit Class Time",
    csEditClassroom: "Edit Classroom",
    csEditAnalyst: "Edit Analyst",
    csMore: "More",
    csBatchDelete: "Batch Delete",
    csSerialNumber: "No.",
    csStageGrade: "Stage/Grade",
    csSubject: "Subject",
    csClassroom: "Classroom",
    csSmartCourse: "Smart Course",
    csLessonStatusName: "Lesson Status",
    csCourseHours: "Supervisor Lessons",
    csAttendance: "Attendance",
    csScheduledStudentCount: "Scheduled/Class Students",
    csRollCall: "Roll Call",
    csConfirmBatchDelete: "Confirm to batch delete these lessons?",
    csConfirmDeleteWithAudition: "There are audition students. After deletion, their status will be marked as cancelled. Delete?",
    csConfirmDelete: "Confirm to delete?",
    csRollCallDetails: "Roll Call Details",
    csStudentDetails: "Student Details",
    csPleaseSelectCourseType: "Please select course type",
    csPleaseSelectAnalyst: "Please select analyst",
    csPleaseSelectLessonStatus: "Please select lesson status",
    csAlreadyCalled: "Already Called",
    csPendingCall: "Pending Call",
    csAddStudent: "Add Student",
    csEditClass: "Edit Class",
    csClassStudents: "Class Students",
    csScheduleInfo: "Schedule Info",
    csRollCallRecord: "Roll Call Record",
    csClassCourse: "Class Course",
    csCustomProduct: "Custom Course Product",
    csComingSoon: "Coming soon...",
    csClassWay: "Class Type",
    csPleaseSelectClassWay: "Please select class type",
    csCourseProduct: "Course Product",
    csPleaseSelectCourseProduct: "Please select course product",
    csPleaseSelectInstructor: "Please select instructor",
    csPleaseEnterClassName: "Please enter class name",
    csPleaseEnterClassContent: "Please enter class content",
    csPleaseEnterRemark: "Please enter remark",
    csStudent: "Student",
    csStudentName: "Student Name",
    csStudentGender: "Student Gender",
    csPhone: "Phone",
    csAvailableHours: "Available Hours",
    csCandidateStudent: "Candidate Students",
    csSelectedStudent: "Selected Students",
    csFilterStudent: "Filter Students",
    csSearchStudentName: "Search student name",
    csPleaseSelectStudentGender: "Please select student gender",
    csAdded: "Added",
    csPeople: "people",
    csNoStudentSelected: "No student selected",
    csStartClassDate: "Start Class Date",
    csPleaseSelectStartDate: "Please select start class date",
    csPleaseSelectClassTime: "Please select class time",
    csAddClassTime: "Add Class Time",
    csAddClassTimeDialogTitle: "Add Class Time Period",
    csAddClassTimeTip: "You are adding a class time period, please enter the time period below",
    csStartTimeLabel: "Start Time",
    csEndTimeLabel: "End Time",
    csPleaseSelectStartTime: "Please select start time",
    csPleaseSelectEndTime: "Please select end time",
    csEndTimeMustGreater: "End time must be greater than start time",
    csAddClassTimeSuccess: "Class time period added successfully",
    csRepeatMode: "Repeat Mode",
    csPleaseSelectRepeatMode: "Please select repeat mode",
    csPleaseSelectRepeatDate: "Please select repeat date",
    csRepeatDate: "Repeat Date",
    csFirstWeek: "Week 1",
    csSecondWeek: "Week 2",
    csThirdWeek: "Week 3",
    csFourthWeek: "Week 4",
    csScheduleCount: "Schedule Count",
    csPleaseEnterScheduleCount: "Please enter schedule count",
    csScheduleCountRange: "Schedule count must be between 1 and 9999",
    csPleaseSelectClassroom: "Please select classroom",
    csAddClassroom: "Add Classroom",
    csEveryWeek: "Every Week",
    csEveryTwoWeeks: "Every 2 Weeks",
    csEveryThreeWeeks: "Every 3 Weeks",
    csEveryFourWeeks: "Every 4 Weeks",
    csClassDate: "Class Date",
    csSelectedDays: "Selected",
    csDayUnit: "days",
    csPrevMonth: "Prev",
    csNextMonth: "Next",
    csThisMonth: "Today",
    csPleaseSelectClassDate: "Please select class date",
    csClassAnalyst: "Analyst",
    csPleaseSelectClassAnalyst: "Please select analyst",
    csStudentAccount: "Student Account",
    csSupervisorStatus: "Supervisor Status",
    csClassHoursTaught: "Classes Taught",
    csPendingClassHours: "Pending Classes",
    csJoinClassTime: "Join Time",
    csGender: "Gender",
    csBuyClassPackage: "Buy Hours",
    csTransferClass: "Transfer",
    csBatchTransfer: "Batch Transfer",
    csMoveOutClass: "Remove from Class",
    csUpdateSchedule: "Update Schedule",
    csBatchUpdateSchedule: "Batch Update Schedule",
    csAssignInstructor: "Assign Instructor",
    csConfirmMoveOut: "Confirm remove from class?",
    csConfirmUpdateSchedule: "Confirm update student schedule?",
    csTargetClass: "Target Class",
    csPleaseSelectTargetClass: "Please select target class",
    csRelearnCourseWarning: " has relearn course in this class, after transfer, will not be able to continue learning. Confirm transfer?",
    csTransferSuccess: "Transfer successful",
    csTransferFailed: "Transfer failed",
    csPendingRollCall: "Pending",
    csCompletedRollCall: "Completed",
    csCallTime: "Call Time",
    /* ─ Roll Call Dialog ── */
    csCallStatus: "Roll Call Status",
    csPresent: "Present",
    csAbsent: "Absent",
    csLeave: "Leave",
    csDeductHours: "Deducted Lessons",
    csRemark: "Remark",
    csContact: "Contact",
    csTeachingHours: "Supervisor Lessons",
    csCourse: "Course",
    csPleaseEnterRemark: "Please enter remark",
    csAddTemporaryStudent: "Add Temporary Student",
    csAddClassStudent: "Add Class Student",
    csPleaseSelectStudentFirst: "Please select students first",
    csAddTemporaryStudentSuccess: "Add temporary student successfully",
    csAddClassStudentSuccess: "Add class student successfully",
    csMaxSelect5Students: "You can select up to 5 students",
    csStudyConsultant: "Class Teacher",
    csEditSchedule: "Edit Schedule",
    csRemainHours: "Remaining Hours",
    csSelectClassDate: "Please select class date",
    csSelectClassTime: "Please select class time",
    csSelectAnalyst: "Please select analyst",
    csSelectClassroom: "Please select classroom",
    csInputTeachingHours: "Please input supervisor lessons",
    csSelectCourse: "Please select course",
    csConfirmLeave: "Confirm leave?",
    /*  Student Details Dialog ── */
    csLearnRecord: "Learning Center Record",
    csCallStatusName: "Roll Call Status",
    csLearnSignStatus: "Sign-in Status",
    csOperator: "Operator",
    csStudentSign: "Student Sign",
    csStudentSignStatus: "Student Sign-in",
    csScheduledHours: "Scheduled Hours",
    csStatus: "Status",
    csScheduled: "Scheduled",
    csNotScheduled: "Not Scheduled",
    csExchangeHours: "Exchange Hours",
    csGiveHours: "Give Hours",
    csSignUp: "Sign Up",
    csModifyRollCallStatus: "Modify Roll Call Status",
    csFindStudent: "Find Student",
    csInputFindStudent: "Please input student to find",
    csInputStudentName: "Please input student name",
    csHeadTeacher: "Head Teacher",
    csSelectStudentFirst: "Please select student first",
    // Supervision Fee Write-off Config
    csSupervisionManagement: "Supervision Management",
    csSupervisionFeeAutoWriteOffConfig: "Supervision Fee Auto Write-off Config",
    csSupervisionFeeWriteOffRule: "Supervision Fee Write-off Rule",
    csAutoWriteOffSupervisionFee: "Auto Write-off Supervision Fee",
    csAutoWriteOffDescription: "When enabled, the system will automatically mark the supervision application as written-off when the supervision fee is fully received, no manual operation required",
    csConfigDescription: "Config Description",
    csFullAmountWriteOff: "Full Amount Write-off: When the supervision fee is fully received, the system will automatically mark the supervision application as \"Written-off\", no manual intervention required.",
    csConfigEffectiveDescription: "After configuration is modified, it takes effect immediately for new supervision fee collections, historical data is not affected.",
    csSaveConfig: "Save Config",
    csConfirmSaveConfig: "Are you sure to save the configuration?",
    csWarning: "Warning",
    // Roll Call Record
    csRollCallRecord: "Roll Call Record",
    csStudentName: "Student Name",
    csPleaseInputStudentName: "Please input student name",
    csSupervisionOrderNo: "Supervision Order No.",
    csPleaseInputOrderNo: "Please input order no.",
    csClassName: "Class Name",
    csPleaseInputClassName: "Please input class name",
    csRollCallDate: "Roll Call Date",
    csPleaseSelectDate: "Please select date",
    csAttendanceStatus: "Attendance Status",
    csAll: "All",
    csPresent: "Present",
    csLeave: "Leave",
    csWriteOffStatus: "Write-off Status",
    csWrittenOff: "Written-off",
    csNotWrittenOff: "Not Written-off",
    csPartialWrittenOff: "Partially Written-off",
    csPleaseSelectWriteOffStatus: "Please select write-off status",
    csSearch: "Search",
    csReset: "Reset",
    csTotalRollCallRecords: "Total {count} roll call records",
    csExport: "Export",
    csSerialNumber: "No.",
    csStudentAccount: "Student Account",
    csClassTime: "Class Time",
    csRollCallTime: "Roll Call Time",
    csStudentConfirmTime: "Student Confirm Time",
    csLessonCount: "Lesson Count",
    csMachineLocation: "Machine Location",
    csAttachment: "Attachment",
    csViewPhoto: "View Photo",
    csImageLoadFailed: "Image load failed",
    csNoImage: "No image available",
    csWriteOff: "Write-off",
    csDetail: "Detail",
    csConfirmWriteOff: "Are you sure to write-off this record?",
    csSupplementRollCall: "+ Supplement Roll Call",
    // Write-off Management
    csWriteOffManagement: "Write-off Management",
    csSupervisionMode: "Supervision Mode",
    csByLesson: "By Lesson",
    csByMonth: "By Month",
    csPleaseInputStudentAccount: "Please input student account",
    csWriteOffRecordList: "Write-off Record List",
    csNewWriteOff: "+ New Write-off",
    csWriteOffLessonCount: "Write-off Lesson/Month",
    csWriteOffAmount: "Write-off Amount",
    csWriteOffTime: "Write-off Time",
    // Supplement Roll Call Dialog
    csSelectClass: "Select Class",
    csPleaseSelectClass: "Please select class",
    csPleaseSelectClassTime: "Please select class time",
    csSelectStudent: "Select Student",
    csPleaseSelectStudent: "Please select student",
    csInputLessonCount: "Input Lesson Count",
    csPleaseInputLessonCount: "Please input lesson count",
    // Roll Call Record Query
    csRollCallDate: "Roll Call Date",
    csTo: "To",
    // Write-off Dialog
    csManualWriteOff: "Manual Write-off",
    csLessonPackageInfo: "Lesson Package Info",
    csProductName: "Product Name",
    csTotalLessonCount: "Total Classes",
    csRemainingLessonCount: "Remaining Classes",
    csLessonUnit: "Classes",
    csWriteOffInfo: "Write-off Info",
    csWriteOffLessonCountLabel: "Write-off Classes",
    csWriteOffBasis: "Write-off Basis",
    csWriteOffByRollCallRecord: "Write-off by Roll Call Record",
    csUnwrittenOffRollCallRecords: "The following are unwritten-off roll call records, multiple selection allowed:",
    csSelectedTotal: "Selected Total",
    csTimePeriod: "Time Period",
    csSupervisionMonthInfo: "Supervision Month Info",
    csTotalMonthCount: "Total Months",
    csRemainingMonthCount: "Remaining Months",
    csMonthUnit: "Months",
    csWriteOffMonthCount: "Write-off Months",
    csDirectWriteOff: "Direct Write-off",
    csUploadScreenshot: "Click to upload communication screenshot confirmed with parent",
    csSupportFormat: "Support jpg, png format",
    csUploadLimitReached: "Upload up to 9 images",
    csUploadFailed: "Image upload failed",
    csOnlyJpgPngAllowed: "Only jpg and png formats are supported",
    csWriteOffWarning: "Please confirm the above information is correct. Write-off will take effect immediately and cannot be revoked.",
    csWriteOffLessonCountExceed: "Write-off classes cannot exceed remaining classes",
    csRemainingLessonCountZero: "Insufficient remaining classes, unable to write off",
    csWriteOffMonthCountExceed: "Write-off months cannot exceed remaining months",
    csRemainingMonthCountZero: "Insufficient remaining months, unable to write off",
    csPleaseSelectRollCallRecord: "Please select roll call records to write off",
    csPleaseUploadScreenshot: "Please upload write-off voucher screenshot",
    csConfirmWriteOff: "Confirm Write-off (Effective Immediately)",
    // Write-off Report
    csStudentKeyword: "Student Name/Account",
    csPleaseInputStudentNameOrAccount: "Please input student name or account",
    csPleaseInputSupervisionOrderNo: "Please input supervision order no",
    csReceivableAmount: "Receivable Amount",
    csActualReceivedAmount: "Actual Received",
    csWrittenOffAmount: "Written-off Amount",
    csUnwrittenOffAmount: "Unwritten-off Amount",
  }
};

